import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  Directive,
} from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { RoleVM } from '../../../Models/RoleVM';
import { MasterDataService } from '../master-data.service';
import { AssignmentConfigurationDto } from '../../../Models/AssignmentConfigurationDto';
import {
  ResourceEditConfigurationDto,
  JobEditConfigurationDto,
} from '../../../Models/EditConfigurationVM';
import {
  ResourceViewConfigurationDto,
  JobViewConfigurationDto,
} from '../../../Models/ViewConfigurationVM';
import { NgxSpinnerService } from 'ngx-spinner';
import { BookingConfigurationDto } from '../../../Models/BookingConfigurationDto';
import { ActionNameEnum, RoleTypeEnum } from '../../../shared/enum';
import {
  JobAddConfigurationDto,
  ResourceAddConfigurationDto,
} from '../../../Models/AddConfigurationVM';
import {
  JobDeleteConfigurationDto,
  ResourceDeleteConfigurationDto,
} from '../../../Models/DeleteConfigurationVM';
import {
  JobReplaceConfigurationDto,
  ResourceReplaceConfigurationDto,
} from '../../../Models/ReplaceConfigurationVM';
import {
  JobReplaceAllConfigurationDto,
  ResourceReplaceAllConfigurationDto,
} from '../../../Models/ReplaceAllConfigurationVM';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ROLE_LAYERS, RoleConfigService } from '../role-config.service';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { RoleApprovalConfigurationVM } from 'app/Models/RoleApprovalConfigurationVM';
import { FeatureLevelConfigVM } from 'app/Models/FeatureLevelConfigVM';
import {
  AppMemoryService,
  DATA_KEY,
} from 'app/shared/sharedservices/appmem.service';
import { RoleReportConfigurationVM } from 'app/Models/RoleReportConfigurationVM';
import { MasterVM } from 'app/Models/MasterVM';

@Component({
  selector: 'app-edit-role-configuration',
  templateUrl: './edit-role-configuration.component.html',
  styleUrls: ['./edit-role-configuration.component.scss'],
})
export class EditRoleConfigurationComponent implements OnInit {
  @Output() onScroll = new EventEmitter<any>();
  approvalArrDtoForSubmission: RoleApprovalConfigurationVM[] = [];
  enableAddInApprovalLayer: boolean = false;
  //#region Global Declaration
  panelOpenState: boolean;
  formGroup: FormGroup;
  modalOption: ModalOptions = {};
  modalRef: BsModalRef;

  assignmentSubAreaList = [];
  assignmentManageCountryList = [];
  assignmentLegalEntityList = [];
  assignmentCompanyCodeList = [];
  assignmentBusinessUnitList = [];
  assignmentEcLocationList = [];
  assignmentOperatingUnitList = [];
  assignmentManagementUnitList = [];
  assignmentDepartmentList = [];
  assignmentServiceLineList = [];
  assignmentSubServiceLineList = [];
  assignmentSubManagementUnitList = [];
  // assignmentRankList = [];
  assignmentLevelList = [];
  assignmentEngCompetencyList = [];
  // assignmentRankList = [];

  // Add Configuration
  resAddSubAreaList = [];
  resAddManageCountryList = [];
  resAddLegalEntityList = [];
  resAddCompanyCodeList = [];
  resAddBusinessUnitList = [];
  resAddEcLocationList = [];
  resAddServiceLineList = [];
  resAddSubServiceLineList = [];
  resAddSubManagementUnitList = [];
  resAddEngCompetencyList = [];
  resAddHRDeptList = [];
  resAddCostCenterList = [];
  resAddRankList = [];

  jobAddSubAreaList = [];
  jobAddManageCountryList = [];
  hasData: boolean = true;
  jobAddCompanyCodeList = [];
  jobAddEcLocationList = [];
  jobAddServiceLineList = [];
  jobAddSubServiceLineList = [];
  jobAddEngCompetencyList = [];
  jobAddRankList = [];
  jobAddJobCategoryList = [];
  jobAddJobStatusList = [];
  jobAddJobStatusBookingList = [];
  jobAddJobCodeList = [];
  jobAddIncludeJobCodeList = [];
  jobAddCostCenterList = [];
  // End

  // Delete Configuration
  resDeleteSubAreaList = [];
  resDeleteManageCountryList = [];
  resDeleteLegalEntityList = [];
  resDeleteCompanyCodeList = [];
  resDeleteBusinessUnitList = [];
  resDeleteEcLocationList = [];
  resDeleteServiceLineList = [];
  resDeleteSubServiceLineList = [];
  resDeleteSubManagementUnitList = [];
  resDeleteEngCompetencyList = [];
  resDeleteHRDeptList = [];
  resDeleteCostCenterList = [];
  resDeleteRankList = [];

  jobDeleteSubAreaList = [];
  jobDeleteManageCountryList = [];
  jobDeleteCompanyCodeList = [];
  jobDeleteEcLocationList = [];
  jobDeleteServiceLineList = [];
  jobDeleteSubServiceLineList = [];
  jobDeleteEngCompetencyList = [];
  jobDeleteRankList = [];
  jobDeleteJobCategoryList = [];
  jobDeleteJobStatusList = [];
  jobDeleteJobStatusBookingList = [];
  jobDeleteJobCodeList = [];
  jobDeleteIncludeJobCodeList = [];
  jobDeleteCostCenterList = [];
  // End

  // Replace Configuration
  resReplaceSubAreaList = [];
  resReplaceManageCountryList = [];
  resReplaceLegalEntityList = [];
  resReplaceCompanyCodeList = [];
  resReplaceBusinessUnitList = [];
  resReplaceEcLocationList = [];
  resReplaceServiceLineList = [];
  resReplaceSubServiceLineList = [];
  resReplaceSubManagementUnitList = [];
  resReplaceEngCompetencyList = [];
  resReplaceHRDeptList = [];
  resReplaceCostCenterList = [];
  resReplaceRankList = [];

  jobReplaceSubAreaList = [];
  jobReplaceManageCountryList = [];
  jobReplaceCompanyCodeList = [];
  jobReplaceEcLocationList = [];
  jobReplaceServiceLineList = [];
  jobReplaceSubServiceLineList = [];
  jobReplaceEngCompetencyList = [];
  jobReplaceRankList = [];
  jobReplaceJobCategoryList = [];
  jobReplaceJobStatusList = [];
  jobReplaceJobStatusBookingList = [];
  jobReplaceJobCodeList = [];
  jobReplaceIncludeJobCodeList = [];
  jobReplaceCostCenterList = [];
  // End

  // Replace All Configuration
  resReplaceAllSubAreaList = [];
  resReplaceAllManageCountryList = [];
  resReplaceAllLegalEntityList = [];
  resReplaceAllCompanyCodeList = [];
  resReplaceAllBusinessUnitList = [];
  resReplaceAllEcLocationList = [];
  resReplaceAllServiceLineList = [];
  resReplaceAllSubServiceLineList = [];
  resReplaceAllSubManagementUnitList = [];
  resReplaceAllEngCompetencyList = [];
  resReplaceAllHRDeptList = [];
  resReplaceAllCostCenterList = [];
  resReplaceAllRankList = [];

  jobReplaceAllSubAreaList = [];
  jobReplaceAllManageCountryList = [];
  jobReplaceAllCompanyCodeList = [];
  jobReplaceAllEcLocationList = [];
  jobReplaceAllServiceLineList = [];
  jobReplaceAllSubServiceLineList = [];
  jobReplaceAllEngCompetencyList = [];
  jobReplaceAllCostCenterList = [];
  jobReplaceAllRankList = [];
  jobReplaceAllJobCategoryList = [];
  jobReplaceAllJobStatusList = [];
  jobReplaceAllJobStatusBookingList = [];
  jobReplaceAllJobCodeList = [];
  jobReplaceAllIncludeJobCodeList = [];
  // End

  // Edit
  resEditSubAreaList = [];
  resEditManageCountryList = [];
  resEditLegalEntityList = [];
  resEditCompanyCodeList = [];
  resEditBusinessUnitList = [];
  resEditEcLocationList = [];
  resEditServiceLineList = [];
  resEditSubServiceLineList = [];
  resEditSubManagementUnitList = [];
  resEditEngCompetencyList = [];
  resEditHRDeptList = [];
  resEditCostCenterList = [];
  resEditRankList = [];

  jobEditSubAreaList = [];
  jobEditManageCountryList = [];
  jobEditCompanyCodeList = [];
  jobEditEcLocationList = [];
  jobEditServiceLineList = [];
  jobEditSubServiceLineList = [];
  jobEditEngCompetencyList = [];
  jobViewCostCenterList = [];
  jobEditRankList = [];
  jobEditJobCategoryList = [];
  jobEditJobStatusList = [];
  jobEditJobStatusBookingList = [];
  jobEditJobCodeList = [];
  jobEditIncludeJobCodeList = [];
  jobEditCostCenterList = [];

  // View
  resViewSubAreaList = [];
  resViewManageCountryList = [];
  resViewLegalEntityList = [];
  resViewCompanyCodeList = [];
  resViewBusinessUnitList = [];
  resViewEcLocationList = [];
  resViewServiceLineList = [];
  resViewSubServiceLineList = [];
  resViewSubManagementUnitList = [];
  resViewEngCompetencyList = [];
  resViewHRDeptList = [];
  resViewCostCenterList = [];
  resViewRankList = [];

  jobViewSubAreaList = [];
  jobViewManageCountryList = [];
  jobViewLegalEntityList = [];
  jobViewCompanyCodeList = [];
  jobViewEcLocationList = [];
  jobViewServiceLineList = [];
  jobViewSubServiceLineList = [];
  jobViewEngCompetencyList = [];
  jobViewRankList = [];
  jobViewJobCategoryList = [];
  jobViewJobStatusList = [];
  jobViewJobStatusBookingList = [];
  jobViewJobCodeList = [];
  jobViewIncludeJobCodeList = [];

  // End

  actionDescriptionList = [];

  assignmentSubAreaSelectedItems = [];
  assignmentManageCountrySelectedItems = [];
  // assignmentBusinessUnitSelectedItems = [];
  assignmentEcLocationSelectedItems = [];
  assignmentLegalEntitySelectedItems = [];
  assignmentCompanyCodeSelectedItems = [];
  assignmentServiceLineSelectedItems = [];
  assignmentSubServiceLineSelectedItems = [];
  assignmentEngCompetencySelectedItems = [];
  assignmentRankSelectedItems = [];
  assignmentSubManagementUnitSelectedItems = [];
  // assignmentRankSelectedItems = [];
  assignmentLevelSelectedItems = [];
  assignmentOperatingUnitSelectedItems = [];
  assignmentManagementUnitSelectedItems = [];
  assignmentDepartmentSelectedItems = [];
  // Add Configuration
  resAddSubAreaSelectedItems = [];
  resAddManageCountrySelectedItems = [];
  resAddBusinessUnitSelectedItems = [];
  resAddEcLocationSelectedItems = [];
  resAddLegalEntitySelectedItems = [];
  resAddCompanyCodeSelectedItems = [];
  resAddServiceLineSelectedItems = [];
  resAddSubServiceLineSelectedItems = [];
  resAddSubManagementUnitSelectedItems = [];
  resAddEngCompetencySelectedItems = [];
  resAddHRDeptSelectedItems = [];
  resAddCostCenterSelectedItems = [];
  resAddRankSelectedItems = [];

  jobAddSubAreaSelectedItems = [];
  jobAddManageCountrySelectedItems = [];
  jobAddEcLocationSelectedItems = [];
  jobAddCompanyCodeSelectedItems = [];
  jobAddServiceLineSelectedItems = [];
  jobAddSubServiceLineSelectedItems = [];
  jobAddEngCompetencySelectedItems = [];
  jobAddRankSelectedItems = [];
  jobAddJobCategorySelectedItems = [];
  jobAddJobStatusSelectedItems = [];
  jobAddJobStatusBookingSelectedItems = [];
  jobAddJobCodeSelectedItems = [];
  jobAddIncludeJobCodeSelectedItems = [];
  jobAddCostCenterSelectedItems = [];

  // End

  // Delete Configuration
  resDeleteSubAreaSelectedItems = [];
  resDeleteManageCountrySelectedItems = [];
  resDeleteBusinessUnitSelectedItems = [];
  resDeleteEcLocationSelectedItems = [];
  resDeleteLegalEntitySelectedItems = [];
  resDeleteCompanyCodeSelectedItems = [];
  resDeleteServiceLineSelectedItems = [];
  resDeleteSubServiceLineSelectedItems = [];
  resDeleteSubManagementUnitSelectedItems = [];
  resDeleteEngCompetencySelectedItems = [];
  resDeleteHRDeptSelectedItems = [];
  resDeleteCostCenterSelectedItems = [];
  resDeleteRankSelectedItems = [];

  jobDeleteSubAreaSelectedItems = [];
  jobDeleteManageCountrySelectedItems = [];
  jobDeleteEcLocationSelectedItems = [];
  jobDeleteCompanyCodeSelectedItems = [];
  jobDeleteServiceLineSelectedItems = [];
  jobDeleteSubServiceLineSelectedItems = [];
  jobDeleteEngCompetencySelectedItems = [];
  jobDeleteRankSelectedItems = [];
  jobDeleteJobCategorySelectedItems = [];
  jobDeleteJobStatusSelectedItems = [];
  jobDeleteJobStatusBookingSelectedItems = [];
  jobDeleteJobCodeSelectedItems = [];
  jobDeleteIncludeJobCodeSelectedItems = [];
  jobDeleteCostCenterSelectedItems = [];

  // End

  // Replace Configuration
  resReplaceSubAreaSelectedItems = [];
  resReplaceManageCountrySelectedItems = [];
  resReplaceBusinessUnitSelectedItems = [];
  resReplaceEcLocationSelectedItems = [];
  resReplaceLegalEntitySelectedItems = [];
  resReplaceCompanyCodeSelectedItems = [];
  resReplaceServiceLineSelectedItems = [];
  resReplaceSubServiceLineSelectedItems = [];
  resReplaceSubManagementUnitSelectedItems = [];
  resReplaceEngCompetencySelectedItems = [];
  resReplaceHRDeptSelectedItems = [];
  resReplaceCostCenterSelectedItems = [];
  resReplaceRankSelectedItems = [];

  jobReplaceSubAreaSelectedItems = [];
  jobReplaceManageCountrySelectedItems = [];
  jobReplaceEcLocationSelectedItems = [];
  jobReplaceCompanyCodeSelectedItems = [];
  jobReplaceServiceLineSelectedItems = [];
  jobReplaceSubServiceLineSelectedItems = [];
  jobReplaceEngCompetencySelectedItems = [];
  jobReplaceRankSelectedItems = [];
  jobReplaceJobCategorySelectedItems = [];
  jobReplaceJobStatusSelectedItems = [];
  jobReplaceJobStatusBookingSelectedItems = [];
  jobReplaceJobCodeSelectedItems = [];
  jobReplaceIncludeJobCodeSelectedItems = [];
  jobReplaceCostCenterSelectedItems = [];

  // End

  // Replace Configuration
  resReplaceAllSubAreaSelectedItems = [];
  resReplaceAllManageCountrySelectedItems = [];
  resReplaceAllBusinessUnitSelectedItems = [];
  resReplaceAllEcLocationSelectedItems = [];
  resReplaceAllLegalEntitySelectedItems = [];
  resReplaceAllCompanyCodeSelectedItems = [];
  resReplaceAllServiceLineSelectedItems = [];
  resReplaceAllSubServiceLineSelectedItems = [];
  resReplaceAllSubManagementUnitSelectedItems = [];
  resReplaceAllEngCompetencySelectedItems = [];
  resReplaceAllHRDeptSelectedItems = [];
  resReplaceAllCostCenterSelectedItems = [];
  resReplaceAllRankSelectedItems = [];

  jobReplaceAllSubAreaSelectedItems = [];
  jobReplaceAllManageCountrySelectedItems = [];
  jobReplaceAllEcLocationSelectedItems = [];
  jobReplaceAllCompanyCodeSelectedItems = [];
  jobReplaceAllServiceLineSelectedItems = [];
  jobReplaceAllSubServiceLineSelectedItems = [];
  jobReplaceAllEngCompetencySelectedItems = [];
  jobReplaceAllRankSelectedItems = [];
  jobReplaceAllJobCategorySelectedItems = [];
  jobReplaceAllJobStatusSelectedItems = [];
  jobReplaceAllJobStatusBookingSelectedItems = [];
  jobReplaceAllJobCodeSelectedItems = [];
  jobReplaceAllIncludeJobCodeSelectedItems = [];
  jobReplaceAllCostCenterSelectedItems = [];

  // End

  resEditSubAreaSelectedItems = [];
  resEditManageCountrySelectedItems = [];
  resEditBusinessUnitSelectedItems = [];
  resEditEcLocationSelectedItems = [];
  resEditLegalEntitySelectedItems = [];
  resEditCompanyCodeSelectedItems = [];
  resEditServiceLineSelectedItems = [];
  resEditSubServiceLineSelectedItems = [];
  resEditSubManagementUnitSelectedItems = [];
  resEditEngCompetencySelectedItems = [];
  resEditHRDeptSelectedItems = [];
  resEditCostCenterSelectedItems = [];
  resEditRankSelectedItems = [];

  jobEditSubAreaSelectedItems = [];
  jobEditManageCountrySelectedItems = [];
  jobEditEcLocationSelectedItems = [];
  jobEditCompanyCodeSelectedItems = [];
  jobEditServiceLineSelectedItems = [];
  jobEditSubServiceLineSelectedItems = [];
  jobEditEngCompetencySelectedItems = [];
  jobEditCostCenterSelectedItems = [];
  jobEditRankSelectedItems = [];
  jobEditJobCategorySelectedItems = [];
  jobEditJobStatusSelectedItems = [];
  jobEditJobStatusBookingSelectedItems = [];
  jobEditJobCodeSelectedItems = [];
  jobEditIncludeJobCodeSelectedItems = [];

  resViewSubAreaSelectedItems = [];
  resViewManageCountrySelectedItems = [];
  resViewBusinessUnitSelectedItems = [];
  resViewEcLocationSelectedItems = [];
  resViewLegalEntitySelectedItems = [];
  resViewCompanyCodeSelectedItems = [];
  resViewServiceLineSelectedItems = [];
  resViewSubServiceLineSelectedItems = [];
  resViewSubManagementUnitSelectedItems = [];
  resViewEngCompetencySelectedItems = [];
  resViewHRDeptSelectedItems = [];
  resViewCostCenterSelectedItems = [];
  resViewRankSelectedItems = [];

  jobViewSubAreaSelectedItems = [];
  jobViewManageCountrySelectedItems = [];
  jobViewEcLocationSelectedItems = [];
  jobViewCompanyCodeSelectedItems = [];
  jobViewServiceLineSelectedItems = [];
  jobViewSubServiceLineSelectedItems = [];
  jobViewEngCompetencySelectedItems = [];
  jobViewCostCenterSelectedItems = [];
  jobViewRankSelectedItems = [];
  jobViewJobCategorySelectedItems = [];
  jobViewJobStatusSelectedItems = [];
  jobViewJobStatusBookingSelectedItems = [];
  jobViewJobCodeSelectedItems = [];
  jobViewIncludeJobCodeSelectedItems = [];
  priorities = [];
  roleTypes = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  role: RoleVM;
  accessRoleName = '';
  selectedRoleType: any;
  selectedPriority: number;
  selectedDelegate: boolean = true;
  remark = '';
  selectedRoleView: boolean = true;
  selectedRoleIsActive: boolean = true;
  assignmentLink: boolean = false;
  assignmentIsActive: boolean = true;
  RoleTypeName: string;
  @Input() selectedRoleTypeName: any;
  // Add configuration
  resAddLink: boolean = false;
  resAddIsActive: boolean = false;
  resAddIsDisabled: boolean = false;
  resAddIndividualView: boolean = false;
  resAddEngagementView: boolean = false;
  resAddIsLikeEdit: boolean = false;
  jobAddLink: boolean = false;
  jobAddIsTR: boolean = true;
  jobAddIsDisabled: boolean = false;

  jobAddIsPended: boolean = false;
  jobAddIndividualView: boolean = false;
  jobAddEngagementView: boolean = false;
  jobAddIsLikeEdit: boolean = false;
  // End
  // Delete configuration
  resDeleteLink: boolean = false;
  resDeleteIsActive: boolean = false;
  resDeleteIsDisabled: boolean = false;
  resDeleteIndividualView: boolean = false;
  resDeleteEngagementView: boolean = false;
  resDeleteIsLikeEdit: boolean = false;
  jobDeleteLink: boolean = false;
  jobDeleteIsTR: boolean = true;
  jobDeleteIsDisabled: boolean = false;

  jobDeleteIsPended: boolean = false;
  jobDeleteIndividualView: boolean = false;
  jobDeleteEngagementView: boolean = false;
  jobDeleteIsLikeEdit: boolean = false;
  // End

  // Replace configuration
  resReplaceLink: boolean = false;
  resReplaceIsActive: boolean = false;
  resReplaceIsDisabled: boolean = false;
  resReplaceIndividualView: boolean = false;
  resReplaceEngagementView: boolean = false;
  resReplaceIsLikeEdit: boolean = false;
  jobReplaceLink: boolean = false;
  jobReplaceIsTR: boolean = true;
  jobReplaceIsDisabled: boolean = false;

  jobReplaceIsPended: boolean = false;
  jobReplaceIndividualView: boolean = false;
  jobReplaceEngagementView: boolean = false;
  jobReplaceIsLikeEdit: boolean = false;
  // End

  // Report Config V1
  assignmentManageReportList = [];
  assignmentManageReportSelectedItems = [];

  // Replace All configuration
  resReplaceAllLink: boolean = false;
  resReplaceAllIsActive: boolean = false;
  resReplaceAllIsDisabled: boolean = false;
  resReplaceAllIndividualView: boolean = false;
  resReplaceAllEngagementView: boolean = false;
  resReplaceAllIsLikeEdit: boolean = false;
  jobReplaceAllLink: boolean = false;
  jobReplaceAllIsTR: boolean = true;
  jobReplaceAllIsDisabled: boolean = false;

  jobReplaceAllIsPended: boolean = false;
  jobReplaceAllIndividualView: boolean = false;
  jobReplaceAllEngagementView: boolean = false;
  jobReplaceAllIsLikeEdit: boolean = false;
  // End
  resEditLink: boolean = false;
  resEditIsActive: boolean = true;
  resEditIsDisabled: boolean = true;
  resEditIndividualView: boolean = false;
  resEditEngagementView: boolean = false;
  jobEditLink: boolean = false;
  jobEditIsTR: boolean = false;
  jobEditIsDisabled: boolean = false;

  jobEditIsPended: boolean = false;
  jobEditIndividualView: boolean = false;
  jobEditEngagementView: boolean = false;

  resViewLink: boolean = false;
  resViewIsActive: boolean = false;
  jobViewLink: boolean = false;
  jobViewIsTR: boolean = false;
  jobViewIsPended: boolean = false;

  bookingCurrentWeekEdit: boolean = false;
  bookingCurrentWeekDelete: boolean = false;
  bookingCurrentWeekAdd: boolean = false;
  bookingCurrentWeekCopy: boolean = false;
  bookingCurrentWeekReplace: boolean = false;
  bookingCurrentWeekReplaceAll: boolean = false;
  bookigTrainingEngagementDelete: boolean = true;
  bookigTrainingEngagementEdit: boolean = true;
  bookigDisabledDelete: boolean = false;
  bookigDisabledEdit: boolean = false;
  bookigDisabledCopy: boolean = false;
  bookigDisabledReplace: boolean = false;
  bookigDisabledReplaceAll: boolean = false;
  bookingDisabledGhostView: boolean = true;
  bookingDisabledGhostEdit: boolean = true;
  bookingDisabledGhostDelete: boolean = true;
  bookingDisabledGhostCopy: boolean = true;
  bookingDisabledGhostReplace: boolean = true;
  buttonText = 'Submit';
  isExistsAccessRole: boolean = false;
  isHomeRetainNotSelected: boolean = false;
  errorMessage: string = '';
  expanded: boolean = false;
  @Input() RoleId: number = 0;
  @Input() actionSelected: string = ActionNameEnum.View;
  actionName = '';
  selectedCoworkers: boolean = false;
  disableActionsGhostBooking: boolean = false;
  actionNameEnum = ActionNameEnum;
  @Input() SaveErrorMessage: string = '';
  dpDisabled: boolean = true;
  roleTypeEnum = RoleTypeEnum;
  prtDisabled: boolean = false;
  dirtyFlag: boolean = false;
  confirmationClickAction: string = 'cancel';
  customResultId: number;
  //public expandMode: number = PanelBarExpandMode.Full;
  overallocation: number;
  unconfirmed: boolean;
  isApproverReq: boolean;
  retainInstance: any;
  isAllretainInstReq: boolean;
  instances: any;
  selectedInstance: number;
  roleIndividualView: boolean = true;
  roleEngagementView: boolean = true;
  roleTeamView: boolean = true;
  previewSubmit: boolean;
  InstanceEnableAddBookingIV: boolean = true;
  selectedHomeBasedInstance: any = null;

  // Feature related variables
  featureField: {}; //ngModel for features level config
  featuresList = [];
  featureLevelDtos: FeatureLevelConfigVM[];
  fetchedFeatureLevelDtos = [];
  featureDataList: any;
  featuresfilterList: any;

  //report 
  reportField: {}; //ngModel for features level config
  reportList = [];
  reportDataList: any;
  arrReportVMData: any;
  
  selectedComponent: boolean = false;
  selectedJobAssignment: boolean = false;
  selectedExpandWallchart: boolean = false;
  selectedExperienceManager: boolean = false;

  accordionOpenStatus: any = {};

  @Input() SaveSuccessMessage: string = '';
  //#endregion

  @Output() onMessageClear = new EventEmitter<any>();

  //#region Cntr
  constructor(
    public restService: RoleConfigService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    private sharedService: SharedServicesService,
    private appMemService: AppMemoryService,
    private masterDataService: MasterDataService
  ) {
    this.priorities = new Array(999).fill(0).map((x, i) => i + 1);
  }
  //#endregion

  //#region Parent Change

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.RoleId != null &&
        changes.RoleId.currentValue != changes.RoleId.previousValue) ||
      (changes.actionSelected != null &&
        changes.actionSelected.currentValue !=
          changes.actionSelected.previousValue)
    ) {
      this.expanded = false;
      if (
        changes?.selectedRoleTypeName != null &&
        changes.selectedRoleTypeName.currentValue != null
      ) {
        if (
          changes.selectedRoleTypeName.currentValue == RoleTypeEnum.ClientServer
        )
          this.selectedRoleType = 1;
        else if (
          changes.selectedRoleTypeName.currentValue ==
          RoleTypeEnum.ResourceAdmin
        )
          this.selectedRoleType = 2;
      }
      this.spinner.show();
      this.clearMainControlls();
      this.bindData().then(() => {
        this.sleep(3500).then(() => {
          this.spinner.hide();
          this.expanded = true;
          setTimeout(() => {
            this.onMessageClear.emit();
          }, 3500);
        });
      });
    }
    // You can also use categoryId.previousValue and
    // categoryId.firstChange for comparing old and new values
    if (this.actionNameEnum.Edit === changes?.actionSelected?.currentValue)
      this.enableAddInApprovalLayer = true;
  }
  //#endregion Parent Change

  //#region  Init
  ngOnInit() {
    this.spinner.show();
    this.setFormControl();
    this.masterData().then(() => {
      this.spinner.hide();
    });
    // }
    //#endregion
    //#region DropDown Setting
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  //#endregion

  //#region User Defined Method
  setFormControl() {
    this.formGroup = new FormGroup({
      RoleType: new FormControl('', [Validators.required]),
      Priority: new FormControl(''),
      AccessRoleName: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[^\s][ A-Za-z0-9-,_]*$/),
        Validators.maxLength(200),
      ]),
      instancesSelected: new FormControl([]),
    });
  }

  onChangeFeatureFieldModel(): void {
    this.makeDirty();
    const excludedFeatures: any = Object.keys(this.featureField).filter(
      (item) => this.featureField[item] === true
    );

    this.featureLevelDtos = excludedFeatures.map((item) => {
      return {
        IsExclude: true,
        RFC_F_ID: this.featuresList.find((it) => it.Text === item).Id,
      };
    });
  }

  clearControls() {
    this.clearMainControlls();
    this.SaveErrorMessage = '';
    this.SaveSuccessMessage = '';
    this.buttonText = 'Submit';
    // window.scroll(0, 0);
    this.onScroll.emit();
  }

  clearMainControlls() {
    this.assignmentSubAreaSelectedItems = [];
    this.assignmentManageCountrySelectedItems = [];
    this.assignmentManageReportSelectedItems = [];
    // this.assignmentBusinessUnitSelectedItems = [];
    this.assignmentEcLocationSelectedItems = [];
    this.assignmentLegalEntitySelectedItems = [];
    this.assignmentCompanyCodeSelectedItems = [];
    this.assignmentServiceLineSelectedItems = [];
    this.assignmentSubServiceLineSelectedItems = [];

    this.assignmentSubManagementUnitSelectedItems = [];
    // this.assignmentRankSelectedItems = [];
    this.assignmentLevelSelectedItems = [];
    this.assignmentEngCompetencySelectedItems = [];
    this.assignmentRankSelectedItems = [];
    this.assignmentOperatingUnitSelectedItems = [];
    this.assignmentManagementUnitSelectedItems = [];
    this.assignmentDepartmentSelectedItems = [];
    this.resAddSubAreaSelectedItems = [];
    this.resAddManageCountrySelectedItems = [];
    this.resAddBusinessUnitSelectedItems = [];
    this.resAddEcLocationSelectedItems = [];
    this.resAddLegalEntitySelectedItems = [];
    this.resAddCompanyCodeSelectedItems = [];
    this.resAddServiceLineSelectedItems = [];
    this.resAddSubServiceLineSelectedItems = [];
    this.resAddSubManagementUnitSelectedItems = [];
    this.resAddEngCompetencySelectedItems = [];
    this.resAddHRDeptSelectedItems = [];
    this.resAddCostCenterSelectedItems = [];
    this.resAddRankSelectedItems = [];

    this.jobAddSubAreaSelectedItems = [];
    this.jobAddManageCountrySelectedItems = [];
    this.jobAddEcLocationSelectedItems = [];
    this.jobAddCompanyCodeSelectedItems = [];
    this.jobAddServiceLineSelectedItems = [];
    this.jobAddSubServiceLineSelectedItems = [];
    this.jobAddEngCompetencySelectedItems = [];
    this.jobAddRankSelectedItems = [];
    this.jobAddJobCategorySelectedItems = [];
    this.jobAddJobStatusSelectedItems = [];
    this.jobAddJobStatusBookingSelectedItems = [];
    this.jobAddJobCodeSelectedItems = [];
    this.jobAddIncludeJobCodeSelectedItems = [];
    this.jobAddCostCenterSelectedItems = [];

    // Delete Configuration
    this.resDeleteSubAreaSelectedItems = [];
    this.resDeleteManageCountrySelectedItems = [];
    this.resDeleteBusinessUnitSelectedItems = [];
    this.resDeleteEcLocationSelectedItems = [];
    this.resDeleteLegalEntitySelectedItems = [];
    this.resDeleteCompanyCodeSelectedItems = [];
    this.resDeleteServiceLineSelectedItems = [];
    this.resDeleteSubServiceLineSelectedItems = [];
    this.resDeleteSubManagementUnitSelectedItems = [];
    this.resDeleteEngCompetencySelectedItems = [];
    this.resDeleteHRDeptSelectedItems = [];
    this.resDeleteCostCenterSelectedItems = [];
    this.resDeleteRankSelectedItems = [];

    this.jobDeleteSubAreaSelectedItems = [];
    this.jobDeleteManageCountrySelectedItems = [];
    this.jobDeleteEcLocationSelectedItems = [];
    this.jobDeleteCompanyCodeSelectedItems = [];
    this.jobDeleteServiceLineSelectedItems = [];
    this.jobDeleteSubServiceLineSelectedItems = [];
    this.jobDeleteEngCompetencySelectedItems = [];
    this.jobDeleteRankSelectedItems = [];
    this.jobDeleteJobCategorySelectedItems = [];
    this.jobDeleteJobStatusSelectedItems = [];
    this.jobDeleteJobStatusBookingSelectedItems = [];
    this.jobDeleteJobCodeSelectedItems = [];
    this.jobDeleteIncludeJobCodeSelectedItems = [];
    this.jobDeleteCostCenterSelectedItems = [];

    // End

    // Replace Configuration
    this.resReplaceSubAreaSelectedItems = [];
    this.resReplaceManageCountrySelectedItems = [];
    this.resReplaceBusinessUnitSelectedItems = [];
    this.resReplaceEcLocationSelectedItems = [];
    this.resReplaceLegalEntitySelectedItems = [];
    this.resReplaceCompanyCodeSelectedItems = [];
    this.resReplaceServiceLineSelectedItems = [];
    this.resReplaceSubServiceLineSelectedItems = [];
    this.resReplaceSubManagementUnitSelectedItems = [];
    this.resReplaceEngCompetencySelectedItems = [];
    this.resReplaceHRDeptSelectedItems = [];
    this.resReplaceCostCenterSelectedItems = [];
    this.resReplaceRankSelectedItems = [];

    this.jobReplaceSubAreaSelectedItems = [];
    this.jobReplaceManageCountrySelectedItems = [];
    this.jobReplaceEcLocationSelectedItems = [];
    this.jobReplaceCompanyCodeSelectedItems = [];
    this.jobReplaceServiceLineSelectedItems = [];
    this.jobReplaceSubServiceLineSelectedItems = [];
    this.jobReplaceEngCompetencySelectedItems = [];
    this.jobReplaceRankSelectedItems = [];
    this.jobReplaceJobCategorySelectedItems = [];
    this.jobReplaceJobStatusSelectedItems = [];
    this.jobReplaceJobStatusBookingSelectedItems = [];
    this.jobReplaceJobCodeSelectedItems = [];
    this.jobReplaceIncludeJobCodeSelectedItems = [];
    this.jobReplaceCostCenterSelectedItems = [];

    // End

    // Replace Configuration
    this.resReplaceAllSubAreaSelectedItems = [];
    this.resReplaceAllManageCountrySelectedItems = [];
    this.resReplaceAllBusinessUnitSelectedItems = [];
    this.resReplaceAllEcLocationSelectedItems = [];
    this.resReplaceAllLegalEntitySelectedItems = [];
    this.resReplaceAllCompanyCodeSelectedItems = [];
    this.resReplaceAllServiceLineSelectedItems = [];
    this.resReplaceAllSubServiceLineSelectedItems = [];
    this.resReplaceAllSubManagementUnitSelectedItems = [];
    this.resReplaceAllEngCompetencySelectedItems = [];
    this.resReplaceAllHRDeptSelectedItems = [];
    this.resReplaceAllCostCenterSelectedItems = [];
    this.resReplaceAllRankSelectedItems = [];

    this.jobReplaceAllSubAreaSelectedItems = [];
    this.jobReplaceAllManageCountrySelectedItems = [];
    this.jobReplaceAllEcLocationSelectedItems = [];
    this.jobReplaceAllCompanyCodeSelectedItems = [];
    this.jobReplaceAllServiceLineSelectedItems = [];
    this.jobReplaceAllSubServiceLineSelectedItems = [];
    this.jobReplaceAllEngCompetencySelectedItems = [];
    this.jobReplaceAllRankSelectedItems = [];
    this.jobReplaceAllJobCategorySelectedItems = [];
    this.jobReplaceAllJobStatusSelectedItems = [];
    this.jobReplaceAllJobStatusBookingSelectedItems = [];
    this.jobReplaceAllJobCodeSelectedItems = [];
    this.jobReplaceAllIncludeJobCodeSelectedItems = [];
    this.jobReplaceAllCostCenterSelectedItems = [];

    // End
    this.resEditSubAreaSelectedItems = [];
    this.resEditManageCountrySelectedItems = [];
    this.resEditBusinessUnitSelectedItems = [];
    this.resEditEcLocationSelectedItems = [];
    this.resEditLegalEntitySelectedItems = [];
    this.resEditCompanyCodeSelectedItems = [];
    this.resEditServiceLineSelectedItems = [];
    this.resEditSubServiceLineSelectedItems = [];
    this.resEditSubManagementUnitSelectedItems = [];
    this.resEditEngCompetencySelectedItems = [];
    this.resEditHRDeptSelectedItems = [];
    this.resEditCostCenterSelectedItems = [];
    this.resEditRankSelectedItems = [];

    this.jobEditSubAreaSelectedItems = [];
    this.jobEditManageCountrySelectedItems = [];
    this.jobEditEcLocationSelectedItems = [];
    this.jobEditCompanyCodeSelectedItems = [];
    this.jobEditServiceLineSelectedItems = [];
    this.jobEditSubServiceLineSelectedItems = [];
    this.jobEditEngCompetencySelectedItems = [];
    this.jobEditCostCenterSelectedItems = [];
    this.jobEditRankSelectedItems = [];
    this.jobEditJobCategorySelectedItems = [];
    this.jobEditJobStatusSelectedItems = [];
    this.jobEditJobStatusBookingSelectedItems = [];
    this.jobEditJobCodeSelectedItems = [];
    this.jobEditIncludeJobCodeSelectedItems = [];

    this.resViewSubAreaSelectedItems = [];
    this.resViewManageCountrySelectedItems = [];
    this.resViewBusinessUnitSelectedItems = [];
    this.resViewEcLocationSelectedItems = [];
    this.resViewLegalEntitySelectedItems = [];
    this.resViewCompanyCodeSelectedItems = [];
    this.resViewServiceLineSelectedItems = [];
    this.resViewSubServiceLineSelectedItems = [];
    this.resViewSubManagementUnitSelectedItems = [];
    this.resViewEngCompetencySelectedItems = [];
    this.resViewHRDeptSelectedItems = [];
    this.resViewCostCenterSelectedItems = [];
    this.resViewRankSelectedItems = [];

    this.jobViewSubAreaSelectedItems = [];
    this.jobViewManageCountrySelectedItems = [];
    this.jobViewEcLocationSelectedItems = [];
    this.jobViewCompanyCodeSelectedItems = [];
    this.jobViewServiceLineSelectedItems = [];
    this.jobViewSubServiceLineSelectedItems = [];
    this.jobViewEngCompetencySelectedItems = [];
    this.jobViewCostCenterSelectedItems = [];
    this.jobViewRankSelectedItems = [];
    this.jobViewJobCategorySelectedItems = [];
    this.jobViewJobStatusSelectedItems = [];
    this.jobViewJobStatusBookingSelectedItems = [];
    this.jobViewJobCodeSelectedItems = [];
    this.jobViewIncludeJobCodeSelectedItems = [];
    this.selectedRoleView = true;
    this.selectedRoleIsActive = true;
    this.assignmentLink = false;
    this.assignmentIsActive = true;

    this.resAddLink = false;
    this.resAddIsActive = false;
    this.resAddIsDisabled = false;
    this.resAddIndividualView = false;
    this.resAddEngagementView = false;
    this.resAddIsLikeEdit = false;
    this.jobAddLink = false;
    this.jobAddIsTR = true;
    this.jobAddIsDisabled = false;
    this.jobAddIsPended = false;
    this.jobAddIndividualView = false;
    this.jobAddEngagementView = false;
    this.jobAddIsLikeEdit = false;

    this.resDeleteLink = false;
    this.resDeleteIsActive = false;
    this.resDeleteIsDisabled = false;
    this.resDeleteIndividualView = false;
    this.resDeleteEngagementView = false;
    this.resDeleteIsLikeEdit = false;
    this.jobDeleteLink = false;
    this.jobDeleteIsTR = true;
    this.jobDeleteIsDisabled = false;
    this.jobDeleteIsPended = false;
    this.jobDeleteIndividualView = false;
    this.jobDeleteEngagementView = false;
    this.jobDeleteIsLikeEdit = false;

    this.resReplaceLink = false;
    this.resReplaceIsActive = false;
    this.resReplaceIsDisabled = false;
    this.resReplaceIndividualView = false;
    this.resReplaceEngagementView = false;
    this.resReplaceIsLikeEdit = false;
    this.jobReplaceLink = false;
    this.jobReplaceIsTR = true;
    this.jobReplaceIsDisabled = false;
    this.jobReplaceIsPended = false;
    this.jobReplaceIndividualView = false;
    this.jobReplaceEngagementView = false;
    this.jobReplaceIsLikeEdit = false;

    this.resReplaceAllLink = false;
    this.resReplaceAllIsActive = false;
    this.resReplaceAllIsDisabled = false;
    this.resReplaceAllIsDisabled = false;
    this.resReplaceAllIndividualView = false;
    this.resReplaceAllEngagementView = false;
    this.jobReplaceAllLink = false;
    this.jobReplaceAllIsTR = true;
    this.jobReplaceAllIsDisabled = false;
    this.jobReplaceAllIsPended = false;
    this.jobReplaceAllIndividualView = false;
    this.jobReplaceAllEngagementView = false;
    this.jobReplaceAllIsLikeEdit = false;

    this.resEditLink = false;
    this.resEditIsActive = false;
    this.resEditIsDisabled = false;
    this.resEditIndividualView = false;
    this.resEditEngagementView = false;
    this.jobEditLink = false;
    this.jobEditIsTR = true;
    this.jobEditIsDisabled = false;
    this.jobEditIsPended = false;
    this.jobEditIndividualView = false;
    this.jobEditEngagementView = false;
    this.resViewLink = false;
    this.resViewIsActive = false;
    this.jobViewLink = false;
    this.jobViewIsTR = false;
    this.jobViewIsPended = false;

    this.bookingCurrentWeekEdit = false;
    this.bookingCurrentWeekDelete = false;
    this.bookingCurrentWeekAdd = false;
    this.bookingCurrentWeekCopy = false;
    this.bookingCurrentWeekReplace = false;
    this.bookingCurrentWeekReplaceAll = false;
    this.bookigTrainingEngagementDelete = true;
    this.bookigTrainingEngagementEdit = true;
    this.bookigDisabledDelete = false;
    this.bookigDisabledEdit = false;
    this.bookigDisabledCopy = false;
    this.bookigDisabledReplace = false;
    this.bookigDisabledReplaceAll = false;
    this.resetGhostBookingActionCheckBoxes();
    this.selectedDelegate = true;
    this.isExistsAccessRole = false;
    this.errorMessage = '';
    this.selectedCoworkers = false;
    this.selectedComponent = false;
    this.selectedExpandWallchart = false;
    this.selectedExperienceManager = false;
    this.selectedJobAssignment = false;
    this.remark = '';
    this.selectedPriority = 0;
    this.SaveErrorMessage = '';
    this.onChangeRoleType();
    this.confirmationClickAction = 'cancel';
    this.customResultId = null;
    this.dirtyFlag = false;
    this.prtDisabled = false;
      // Report Config V1
    this.assignmentManageReportList = [];
    this.assignmentManageReportSelectedItems = [];
  }

  populateRoleApprovalDTO(data) {
    this.makeDirty();
    this.approvalArrDtoForSubmission = data;
  }

  bindData() {
    //debugger;
    return new Promise<void>((resolve) => {
      this.restService.getRolConfiguration(this.RoleId).subscribe((data) => {
        //this.RoleId = !this.isCopy ? data.R_ID : 0;
        if (
          this.actionSelected == ActionNameEnum.Edit ||
          this.actionSelected == ActionNameEnum.View ||
          this.actionSelected == ActionNameEnum.Copy
        ) {
          this.selectedRoleType = data.R_RT_ID;
          this.RoleTypeName = data.RT_Name;
          this.accessRoleName = data.R_Name;
          if (data.RT_Name == RoleTypeEnum.ResourceAdmin)
            this.prtDisabled = true;
          else this.prtDisabled = false;
        } else {
          this.selectedRoleType = '';
          this.accessRoleName = '';
          this.prtDisabled = false;
        }

        if (this.actionSelected != ActionNameEnum.View) {
          this.actionName = this.actionSelected;
        }
        this.selectedPriority = data.R_Priority;
        this.remark = data.R_Comments;
        this.selectedRoleView = data.R_View;
        this.selectedDelegate = data.R_Delegate;
        this.resAddLink = data.R_RADLinkConfig;
        this.resEditLink = data.R_RELinkConfig;
        this.resDeleteLink = data.R_RDLinkConfig;
        this.resReplaceLink = data.R_RRLinkConfig;
        this.resReplaceAllLink = data.R_RRALinkConfig;
        this.resViewLink = data.R_RVLinkConfig;
        this.jobAddLink = data.R_JADLinkConfig;
        this.jobEditLink = data.R_JELinkConfig;
        this.jobDeleteLink = data.R_JDLinkConfig;
        this.jobReplaceLink = data.R_JRLinkConfig;
        this.jobReplaceAllLink = data.R_JRALinkConfig;
        this.jobViewLink = data.R_JVLinkConfig;
        this.assignmentLink = data.R_RALinkConfig;
        this.selectedRoleIsActive = data.R_IsActive;
        this.selectedCoworkers = data.R_CoWorker;
        this.selectedComponent = data.R_Enable_CompDescr;
        this.selectedExpandWallchart = data.R_Expand_Wallchart;
        // v1
        this.selectedExperienceManager = data.R_Experience_Manager;
        this.selectedJobAssignment = data.R_Enable_JobAssignDescr;
        this.disableActionsGhostBooking = data.R_Ghost;
        this.selectedInstance = data.R_I_ID == 0 ? 1 : data.R_I_ID;
        this.getUserInstances();
        this.overallocation = data.R_OverAllocation;
        this.isAllretainInstReq = data.R_MUltipleInstance;
        this.unconfirmed = data.R_Unconfirmed;
        this.isApproverReq = data.R_IsReqdApproval;
        this.roleIndividualView = data.R_InstEnable_IV;
        this.roleEngagementView = data.R_InstEnable_EV;
        this.roleTeamView = data.R_InstEnable_TV;
        this.previewSubmit = data.R_PreviewSubmit;
        this.InstanceEnableAddBookingIV = data.R_InstEnable_AddBooking;
        this.selectedHomeBasedInstance = data.R_Home_InstanceID;

        if (data.RoleApprovalConfigurationDtos != null) {
          this.approvalArrDtoForSubmission = [
            ...data.RoleApprovalConfigurationDtos,
          ];
        }

        if (data.AssignmentConfigurationDto != null) {
          this.assignmentIsActive =
            data.AssignmentConfigurationDto.RAR_ISACTIVE;

          this.assignmentSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentSubAreas
            );
          this.assignmentManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentManagerialCountries
            );
    
           // Report Role set data
           this.arrReportVMData = data.RoleReportConfigurationDtos;
           this.getReportDetailsMasterVM(this.arrReportVMData);
          
          this.assignmentEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentEconomicLocations
            );
          this.assignmentOperatingUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentOperatingUnits
            );
          this.assignmentManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentManageUnits
            );
          this.assignmentDepartmentSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentDepartment
            );
          this.assignmentLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentLegalEntities
            );
          this.assignmentCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentCompanyCodes
            );
          this.assignmentServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentServiceLines
            );
          this.assignmentSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentSubServiceLines
            );
          this.assignmentEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.assignmentCompetencies
            );
          this.assignmentLevelSelectedItems =
            this.masterDataService.getDummyArray(
              data.AssignmentConfigurationDto.activityTypes
            );
        }

        // Add Config

        if (data.ResourceAddConfigurationDto != null) {
          this.resAddSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddSubAreas
            );
          this.resAddManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddManagerialCountries
            );
          this.resAddBusinessUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddBusinessUnits
            );
          this.resAddEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddEconomicLocations
            );
          this.resAddLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddLegalEntities
            );
          this.resAddCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddCompanyCodes
            );
          this.resAddServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddServiceLines
            );
          this.resAddSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddSubServiceLines
            );
          this.resAddSubManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddSubManageUnits
            );
          this.resAddEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddCompetencies
            );
          this.resAddHRDeptSelectedItems = this.masterDataService.getDummyArray(
            data.ResourceAddConfigurationDto.ResAddDepartments
          );
          this.resAddCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceAddConfigurationDto.ResAddCostCenters
            );
        }

        if (data.JobAddConfigurationDto != null) {
          this.jobAddSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddSubAreas
            );
          this.jobAddManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddManagerialCountries
            );
          this.jobAddCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddCompanyCodes
            );
          this.jobAddEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddEconomicLocations
            );
          this.jobAddServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddServiceLines
            );
          this.jobAddSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddSubServiceLines
            );
          this.jobAddEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddCompetencies
            );
          this.jobAddJobCategorySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddJobCategories
            );
          this.jobAddJobStatusSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddJobStatuses
            );
          this.jobAddJobStatusBookingSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddJobStatusBookings
            );
          this.jobAddJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddJobCode
            );
          this.jobAddIncludeJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddIncludeJobCode
            );
          this.jobAddCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobAddConfigurationDto.JobAddCostCenters
            );
        }
        //END

        // Delete Config
        if (data.ResourceDeleteConfigurationDto != null) {
          this.resDeleteSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteSubAreas
            );
          this.resDeleteManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteManagerialCountries
            );
          this.resDeleteBusinessUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteBusinessUnits
            );
          this.resDeleteEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteEconomicLocations
            );
          this.resDeleteLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteLegalEntities
            );
          this.resDeleteCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteCompanyCodes
            );
          this.resDeleteServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteServiceLines
            );
          this.resDeleteSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteSubServiceLines
            );
          this.resDeleteSubManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteSubManageUnits
            );
          this.resDeleteEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteCompetencies
            );
          this.resDeleteHRDeptSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteDepartments
            );
          this.resDeleteCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceDeleteConfigurationDto.ResDeleteCostCenters
            );
        }
        if (data.JobDeleteConfigurationDto != null) {
          this.jobDeleteSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteSubAreas
            );
          this.jobDeleteManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteManagerialCountries
            );
          this.jobDeleteCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteCompanyCodes
            );
          this.jobDeleteEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteEconomicLocations
            );
          this.jobDeleteServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteServiceLines
            );
          this.jobDeleteSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteSubServiceLines
            );
          this.jobDeleteEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteCompetencies
            );
          this.jobDeleteJobCategorySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteJobCategories
            );
          this.jobDeleteJobStatusSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteJobStatuses
            );
          this.jobDeleteJobStatusBookingSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteJobStatusBookings
            );
          this.jobDeleteIncludeJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteIncludeJobCode
            );
          this.jobDeleteJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteJobCode
            );
          this.jobDeleteCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobDeleteConfigurationDto.JobDeleteCostCenters
            );
        }
        //END

        // Replace Config
        if (data.ResourceReplaceConfigurationDto != null) {
          this.resReplaceSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceSubAreas
            );
          this.resReplaceManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceManagerialCountries
            );
          this.resReplaceBusinessUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceBusinessUnits
            );
          this.resReplaceEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceEconomicLocations
            );
          this.resReplaceLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceLegalEntities
            );
          this.resReplaceCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceCompanyCodes
            );
          this.resReplaceServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceServiceLines
            );
          this.resReplaceSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceSubServiceLines
            );
          this.resReplaceSubManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceSubManageUnits
            );
          this.resReplaceEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceCompetencies
            );
          this.resReplaceHRDeptSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceDepartments
            );
          this.resReplaceCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceConfigurationDto.ResReplaceCostCenters
            );
        }
        if (data.JobReplaceConfigurationDto != null) {
          this.jobReplaceSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceSubAreas
            );
          this.jobReplaceManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceManagerialCountries
            );
          this.jobReplaceCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceCompanyCodes
            );
          this.jobReplaceEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceEconomicLocations
            );
          this.jobReplaceServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceServiceLines
            );
          this.jobReplaceSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceSubServiceLines
            );
          this.jobReplaceEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceCompetencies
            );
          this.jobReplaceJobCategorySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceJobCategories
            );
          this.jobReplaceJobStatusSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceJobStatuses
            );
          this.jobReplaceJobStatusBookingSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceJobStatusBookings
            );
          this.jobReplaceJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceJobCode
            );
          this.jobReplaceIncludeJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceIncludeJobCode
            );
          this.jobReplaceCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceConfigurationDto.JobReplaceCostCenters
            );
        }
        //END
        // Replace All Config

        if (data.ResourceReplaceAllConfigurationDto != null) {
          this.resReplaceAllSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllSubAreas
            );
          this.resReplaceAllManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto
                .ResReplaceAllManagerialCountries
            );
          this.resReplaceAllBusinessUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllBusinessUnits
            );
          this.resReplaceAllEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto
                .ResReplaceAllEconomicLocations
            );
          this.resReplaceAllLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllLegalEntities
            );
          this.resReplaceAllCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllCompanyCodes
            );
          this.resReplaceAllServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllServiceLines
            );
          this.resReplaceAllSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto
                .ResReplaceAllSubServiceLines
            );
          this.resReplaceAllSubManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto
                .ResReplaceAllSubManageUnits
            );
          this.resReplaceAllEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllCompetencies
            );
          this.resReplaceAllHRDeptSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllDepartments
            );
          this.resReplaceAllCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceReplaceAllConfigurationDto.ResReplaceAllCostCenters
            );
        }
        if (data.JobReplaceAllConfigurationDto != null) {
          this.jobReplaceAllSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllSubAreas
            );
          this.jobReplaceAllManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto
                .JobReplaceAllManagerialCountries
            );
          this.jobReplaceAllCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllCompanyCodes
            );
          this.jobReplaceAllEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllEconomicLocations
            );
          this.jobReplaceAllServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllServiceLines
            );
          this.jobReplaceAllSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllSubServiceLines
            );
          this.jobReplaceAllEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllCompetencies
            );
          this.jobReplaceAllJobCategorySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllJobCategories
            );
          this.jobReplaceAllJobStatusSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllJobStatuses
            );
          this.jobReplaceAllJobStatusBookingSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllJobStatusBookings
            );
          this.jobReplaceAllJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllJobCode
            );
          this.jobReplaceAllIncludeJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllIncludeJobCode
            );
          this.jobReplaceAllCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobReplaceAllConfigurationDto.JobReplaceAllCostCenters
            );
        }
        //END
        if (data.ResourceEditConfigurationDto != null) {
          this.resEditSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditSubAreas
            );
          this.resEditManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditManagerialCountries
            );
          this.resEditBusinessUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditBusinessUnits
            );
          this.resEditEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditEconomicLocations
            );
          this.resEditLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditLegalEntities
            );
          this.resEditCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditCompanyCodes
            );
          this.resEditServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditServiceLines
            );
          this.resEditSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditSubServiceLines
            );
          this.resEditSubManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditSubManageUnits
            );
          this.resEditEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditCompetencies
            );
          this.resEditHRDeptSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditDepartments
            );
          this.resEditCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceEditConfigurationDto.ResEditCostCenters
            );
        }

        if (data.JobEditConfigurationDto != null) {
          this.jobEditSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditSubAreas
            );
          this.jobEditCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditCompanyCodes
            );
          this.jobEditManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditManagerialCountries
            );
          this.jobEditIncludeJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditIncludeJobCode
            );
          this.jobEditEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditEconomicLocations
            );
          this.jobEditServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditServiceLines
            );
          this.jobEditSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditSubServiceLines
            );
          this.jobEditEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditCompetencies
            );
          this.jobEditCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditCostCenters
            );
          this.jobEditJobCategorySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditJobCategories
            );
          this.jobEditJobStatusSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditJobStatuses
            );
          this.jobEditJobStatusBookingSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditJobStatusBookings
            );
          this.jobEditJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobEditConfigurationDto.JobEditJobCode
            );
        }
        if (data.ResourceViewConfigurationDto != null) {
          this.resViewSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewSubAreas
            );
          this.resViewManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewManagerialCountries
            );
          this.resViewBusinessUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewBusinessUnits
            );
          this.resViewEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewEconomicLocations
            );
          this.resViewLegalEntitySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewLegalEntities
            );
          this.resViewCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewCompanyCodes
            );
          this.resViewServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewServiceLines
            );
          this.resViewSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewSubServiceLines
            );
          this.resViewSubManagementUnitSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewSubManageUnits
            );
          this.resViewEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewCompetencies
            );
          this.resViewHRDeptSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewDepartments
            );
          this.resViewCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.ResourceViewConfigurationDto.ResViewCostCenters
            );
        }
        if (data.JobViewConfigurationDto != null) {
          this.jobViewSubAreaSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewSubAreas
            );
          this.jobViewCompanyCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewCompanyCodes
            );
          this.jobViewEcLocationSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewEconomicLocations
            );
          this.jobViewServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewServiceLines
            );
          this.jobViewSubServiceLineSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewSubServiceLines
            );
          this.jobViewEngCompetencySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewCompetencies
            );
          this.jobViewCostCenterSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewCostCenters
            );
          this.jobViewJobStatusSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewJobStatuses
            );
          this.jobViewJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewJobCode
            );

          this.jobViewManageCountrySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewManagerialCountries
            );
          this.jobViewJobStatusBookingSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewJobStatusBookings
            );
          this.jobViewIncludeJobCodeSelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewIncludeJobCode
            );
          this.jobViewJobCategorySelectedItems =
            this.masterDataService.getDummyArray(
              data.JobViewConfigurationDto.JobViewJobCategories
            );

        }
        // this.sortDataBasedOnSelectedItems(this.resEditSubServiceLineList, this.resEditSubServiceLineSelectedItems);
        if (data.ResourceEditConfigurationDto != null) {
          this.resEditIsActive =
            data.ResourceEditConfigurationDto.RREC_RInactive;
          this.resEditIsDisabled =
            data.ResourceEditConfigurationDto.RREC_ISDisabled;
          this.resEditIndividualView =
            data.ResourceEditConfigurationDto.RREC_IV_Disabled;
          this.resEditEngagementView =
            data.ResourceEditConfigurationDto.RREC_EV_Disabled;
        }
        if (data.ResourceAddConfigurationDto != null) {
          this.resAddIsActive = data.ResourceAddConfigurationDto.RRAC_RInactive;
          this.resAddIsDisabled =
            data.ResourceAddConfigurationDto.RRAC_ISDisabled;
          this.resAddIndividualView =
            data.ResourceAddConfigurationDto.RRAC_IV_Disabled;
          this.resAddEngagementView =
            data.ResourceAddConfigurationDto.RRAC_EV_Disabled;
          this.resAddIsLikeEdit =
            data.ResourceAddConfigurationDto.RRAC_ISLikeEdit;
        }
        if (data.ResourceDeleteConfigurationDto != null) {
          this.resDeleteIsActive =
            data.ResourceDeleteConfigurationDto.RRDC_RInactive;
          this.resDeleteIsDisabled =
            data.ResourceDeleteConfigurationDto.RRDC_ISDisabled;
          this.resDeleteIndividualView =
            data.ResourceDeleteConfigurationDto.RRDC_IV_Disabled;
          this.resDeleteEngagementView =
            data.ResourceDeleteConfigurationDto.RRDC_EV_Disabled;
          this.resDeleteIsLikeEdit =
            data.ResourceDeleteConfigurationDto.RRDC_ISLikeEdit;
        }
        if (data.ResourceReplaceConfigurationDto != null) {
          this.resReplaceIsActive =
            data.ResourceReplaceConfigurationDto.RRRC_RInactive;
          this.resReplaceIsDisabled =
            data.ResourceReplaceConfigurationDto.RRRC_ISDisabled;
          this.resReplaceIndividualView =
            data.ResourceReplaceConfigurationDto.RRRC_IV_Disabled;
          this.resReplaceEngagementView =
            data.ResourceReplaceConfigurationDto.RRRC_EV_Disabled;
          this.resReplaceIsLikeEdit =
            data.ResourceReplaceConfigurationDto.RRRC_ISLikeEdit;
        }
        if (data.ResourceReplaceAllConfigurationDto != null) {
          this.resReplaceAllIsActive =
            data.ResourceReplaceAllConfigurationDto.RRRAC_RInactive;
          this.resReplaceAllIsDisabled =
            data.ResourceReplaceAllConfigurationDto.RRRAC_ISDisabled;
          this.resReplaceAllIndividualView =
            data.ResourceReplaceAllConfigurationDto.RRRAC_IV_Disabled;
          this.resReplaceAllEngagementView =
            data.ResourceReplaceAllConfigurationDto.RRRAC_EV_Disabled;
          this.resReplaceAllIsLikeEdit =
            data.ResourceReplaceAllConfigurationDto.RRRAC_ISLikeEdit;
        }
        if (data.JobEditConfigurationDto != null) {
          this.jobEditIsTR = data.JobEditConfigurationDto.RJEC_Learning;
          this.jobEditIsDisabled = data.JobEditConfigurationDto.RJEC_ISDisabled;
          this.jobEditIsPended = data.JobEditConfigurationDto.RJEC_IsPended;
          this.jobEditIndividualView =
            data.JobEditConfigurationDto.RJEC_IV_Disabled;
          this.jobEditEngagementView =
            data.JobEditConfigurationDto.RJEC_EV_Disabled;
        }
        if (data.JobAddConfigurationDto != null) {
          this.jobAddIsTR = data.JobAddConfigurationDto.RJAC_Learning;
          this.jobAddIsDisabled = data.JobAddConfigurationDto.RJAC_ISDisabled;
          this.jobAddIsPended = data.JobAddConfigurationDto.RJAC_IsPended;
          this.jobAddIsLikeEdit = data.JobAddConfigurationDto.RJAC_ISLikeEdit;
          this.jobAddIndividualView =
            data.JobAddConfigurationDto.RJAC_IV_Disabled;
          this.jobAddEngagementView =
            data.JobAddConfigurationDto.RJAC_EV_Disabled;
        }
        if (data.JobDeleteConfigurationDto != null) {
          this.jobDeleteIsTR = data.JobDeleteConfigurationDto.RJDC_Learning;
          this.jobDeleteIsDisabled =
            data.JobDeleteConfigurationDto.RJDC_ISDisabled;
          this.jobDeleteIsPended = data.JobDeleteConfigurationDto.RJDC_IsPended;
          this.jobDeleteIsLikeEdit =
            data.JobDeleteConfigurationDto.RJDC_ISLikeEdit;
          this.jobDeleteIndividualView =
            data.JobDeleteConfigurationDto.RJDC_IV_Disabled;
          this.jobDeleteEngagementView =
            data.JobDeleteConfigurationDto.RJDC_EV_Disabled;
        }
        if (data.JobReplaceConfigurationDto != null) {
          this.jobReplaceIsTR = data.JobReplaceConfigurationDto.RJRC_Learning;
          this.jobReplaceIsDisabled =
            data.JobReplaceConfigurationDto.RJRC_ISDisabled;
          this.jobReplaceIsPended =
            data.JobReplaceConfigurationDto.RJRC_IsPended;
          this.jobReplaceIsLikeEdit =
            data.JobReplaceConfigurationDto.RJRC_ISLikeEdit;
          this.jobReplaceIndividualView =
            data.JobReplaceConfigurationDto.RJRC_IV_Disabled;
          this.jobReplaceEngagementView =
            data.JobReplaceConfigurationDto.RJRC_EV_Disabled;
        }

        if (data.JobReplaceAllConfigurationDto != null) {
          this.jobReplaceAllIsTR =
            data.JobReplaceAllConfigurationDto.RJRAC_Learning;
          this.jobReplaceAllIsDisabled =
            data.JobReplaceAllConfigurationDto.RJRAC_ISDisabled;
          this.jobReplaceAllIsPended =
            data.JobReplaceAllConfigurationDto.RJRAC_IsPended;
          this.jobReplaceAllIsLikeEdit =
            data.JobReplaceAllConfigurationDto.RJRAC_ISLikeEdit;
          this.jobReplaceAllIndividualView =
            data.JobReplaceAllConfigurationDto.RJRAC_IV_Disabled;
          this.jobReplaceAllEngagementView =
            data.JobReplaceAllConfigurationDto.RJRAC_EV_Disabled;
        }
        if (data.ResourceViewConfigurationDto != null)
          this.resViewIsActive =
            data.ResourceViewConfigurationDto.RRVC_RInactive;
        if (data.JobViewConfigurationDto != null) {
          this.jobViewIsTR = data.JobViewConfigurationDto.RJVC_Learning;
          this.jobViewIsPended = data.JobViewConfigurationDto.RJVC_IsPended;
        }
        if (data.BookingConfigurationDto != null) {
          this.bookingCurrentWeekEdit =
            data.BookingConfigurationDto.RBC_BIDEWEEK;
          this.bookingCurrentWeekDelete =
            data.BookingConfigurationDto.RBC_BIDDWEEK;
          this.bookingCurrentWeekAdd =
            data.BookingConfigurationDto.RBC_BIDAWEEK;
          this.bookingCurrentWeekCopy =
            data.BookingConfigurationDto.RBC_BIDCWEEK;
          this.bookingCurrentWeekReplace =
            data.BookingConfigurationDto.RBC_BIDRWEEK;
          this.bookingCurrentWeekReplaceAll =
            data.BookingConfigurationDto.RBC_BIDRAWEEK;
          this.bookigTrainingEngagementDelete =
            data.BookingConfigurationDto.RBC_BIDDTRNG;
          this.bookigTrainingEngagementEdit =
            data.BookingConfigurationDto.RBC_BIDETRNG;
          this.bookigDisabledDelete = data.BookingConfigurationDto.RBC_BIDDDELT;
          this.bookigDisabledEdit = data.BookingConfigurationDto.RBC_BIDEEDIT;
          this.bookigDisabledCopy = data.BookingConfigurationDto.RBC_BIDCCOPY;
          this.bookigDisabledReplace =
            data.BookingConfigurationDto.RBC_BIDRRPLC;
          this.bookigDisabledReplaceAll =
            data.BookingConfigurationDto.RBC_BIDRARPLCA;
          this.bookingDisabledGhostView =
            data.BookingConfigurationDto.RBC_BIDVGhost;
          this.bookingDisabledGhostEdit =
            data.BookingConfigurationDto.RBC_BIDEGhost;
          this.bookingDisabledGhostDelete =
            data.BookingConfigurationDto.RBC_BIDDGhost;
          this.bookingDisabledGhostCopy =
            data.BookingConfigurationDto.RBC_BIDCGhost;
          this.bookingDisabledGhostReplace =
            data.BookingConfigurationDto.RBC_BIDRGhost;
        }
        this.fetchedFeatureLevelDtos = data.RoleFeatureLevelConfigurationDtos;
        if (this.fetchedFeatureLevelDtos?.length)
          this.bindFeatureLevelFields(this.fetchedFeatureLevelDtos);
      });

      resolve();
    });
  }

   //v3
  private getReportDetailsMasterVM(Reportdata)
   {

     this.assignmentManageReportList = [...this.masterDataService.dataReport];
     let reportdataVM : MasterVM[] = [];
     if((Reportdata) && (this.assignmentManageReportList))
     {
        Reportdata.forEach(az => {
              let obj = new MasterVM;
              obj.ID = az.RAC_RP_ID;
              obj.Text = this.assignmentManageReportList.find(dd => dd.Id == az.RAC_RP_ID).Text;
              reportdataVM.push(obj);
        });
    }
     
      this.assignmentManageReportSelectedItems =
       this.masterDataService.getDummyArray(
           reportdataVM
          //data.RoleReportConfigurationDtos
       );
   }


  sortDataBasedOnSelectedItems = (totalArray, selectedArray) => {
    const selectedArrayId = selectedArray.map((selected) => selected.Id);
    const commonItems = totalArray.filter(
      (item) => selectedArrayId.indexOf(item.Id) > -1
    );
    const otherItems = totalArray.filter(
      (item) => selectedArrayId.indexOf(item.Id) === -1
    );
    return [...commonItems, ...otherItems];
  };

  bindFeatureLevelFields(arr) {
    const excludedIds = arr
      .filter((item) => item.IsExclude)
      .map((item) => item.RFC_F_ID);

    const objNamesExcluded = excludedIds.map((item) => {
      return this.featuresList.find((innItem) => innItem.Id === item)?.Text;
    });

    objNamesExcluded.forEach((item) => {
      if (item) this.featureField[item] = true;
    });
    this.featureLevelDtos = arr;
  }

  makeDirty() {
    if (!this.dirtyFlag) {
      this.dirtyFlag = true;
    }
  }

  managePrioirtyDisable() {
    let csRole = this.roleTypes.find((x) => x.ID == this.selectedRoleType);
    if (csRole != null && csRole.Code == this.roleTypeEnum.ClientServer) {
      if (this.selectedPriority == 0 || this.selectedPriority == null)
        this.selectedPriority = 1;
      this.prtDisabled = false;
    } else if (
      csRole != null &&
      csRole.Code == this.roleTypeEnum.ResourceAdmin
    ) {
      this.selectedPriority = 0;
      this.prtDisabled = true;
      this.isApproverReq = false;
    } else {
      this.selectedPriority = 0;
      this.prtDisabled = false;
    }
  }

  onChangeMultiInsta(): void {
    this.makeDirty();
    this.roleIndividualView = true;
    this.roleEngagementView = true;
    this.roleTeamView = true;
    this.InstanceEnableAddBookingIV = true;
    this.selectedHomeBasedInstance = null;
    this.isHomeRetainNotSelected = false;
  }

  onChangeNewBookingIV(): void {
    this.makeDirty();
    this.selectedHomeBasedInstance = null;
    this.isHomeRetainNotSelected = false;
  }

  setControlsData = (data) => {
    if (data?.ActionDescriptionList != null) {
      const dummyArray = this.masterDataService.getDummyArray(
        data.ActionDescriptionList
      );
      this.actionDescriptionList = [...dummyArray];
      this.actionDescriptionList = this.actionDescriptionList.filter(
        (item) => item.Id != 6 && item.Id != 3
      );
    }
    if (data.FeatureList != null) {
      this.featureDataList = data.FeatureList;
      this.manageFeatureLevelConfiguration();
    }

    // if (data.reportList != null) {
    //   this.reportDataList = data.reportList;
    //   this.manageReportConfiguration();
    // }
    this.masterDataService.setControlsData(data);
  };

  onAccordionOpen = (event, type) => {
    event.preventDefault();
    if (this.panelOpenState) {
      if (
        !this.accordionOpenStatus[type] ||
        this.accordionOpenStatus[type] === false
      ) {
        this.spinner.show();
      }
      this.sleep(500).then(() => {
        switch (type) {
          case ROLE_LAYERS.VIEW_CONFIG:
            if (!this.resViewSubAreaList.length) {
              this.resViewSubAreaList = [...this.masterDataService.dataSubArea];
              this.resViewManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resViewLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.resViewCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resViewBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.resViewEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resViewServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resViewSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resViewSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.resViewEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resViewHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resViewRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.resViewCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobViewSubAreaList = [...this.masterDataService.dataSubArea];
              this.jobViewManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobViewCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
              this.jobViewLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobViewCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobViewEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobViewServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobViewSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobViewEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobViewRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.jobViewJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobViewJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobViewJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobViewJobCodeList = [...this.masterDataService.dataJobCode];
              this.jobViewIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
            }
            break;

          case ROLE_LAYERS.EDIT_CONFIG:
            if (!this.resEditSubAreaList.length) {
              this.resEditSubAreaList = [...this.masterDataService.dataSubArea];
              this.resEditManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resEditLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.resEditCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resEditBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.resEditEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resEditServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resEditSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resEditSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.resEditEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resEditHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resEditRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.resEditCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobEditSubAreaList = [...this.masterDataService.dataSubArea];
              this.jobEditManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobEditCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
              this.jobEditCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobEditEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobEditServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobEditSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobEditEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobEditRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.jobEditJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobEditJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobEditJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobEditJobCodeList = [...this.masterDataService.dataJobCode];
              this.jobEditIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
            }
            break;

          case ROLE_LAYERS.ADD_CONFIG:
            if (!this.resAddSubAreaList.length) {
              this.resAddSubAreaList = [...this.masterDataService.dataSubArea];
              this.resAddManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resAddLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.resAddCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resAddBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.resAddEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resAddServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resAddSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resAddSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.resAddEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resAddHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resAddRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.resAddCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobAddSubAreaList = [...this.masterDataService.dataSubArea];
              this.jobAddManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobAddCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
              this.jobAddCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobAddEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobAddServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobAddSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobAddEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobAddRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.jobAddJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobAddJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobAddJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobAddJobCodeList = [...this.masterDataService.dataJobCode];
              this.jobAddIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
            }
            break;

          case ROLE_LAYERS.DELETE_CONFIG:
            if (!this.resDeleteSubAreaList.length) {
              this.resDeleteSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.resDeleteManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resDeleteLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.resDeleteCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resDeleteBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.resDeleteEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resDeleteServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resDeleteSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resDeleteSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.resDeleteEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resDeleteHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resDeleteRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.resDeleteCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobDeleteSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.jobDeleteManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobDeleteCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
              this.jobDeleteCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobDeleteEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobDeleteServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobDeleteSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobDeleteEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobDeleteRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.jobDeleteJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobDeleteJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobDeleteJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobDeleteJobCodeList = [
                ...this.masterDataService.dataJobCode,
              ];
              this.jobDeleteIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
            }
            break;

          case ROLE_LAYERS.REPLACE_CONFIG:
            if (!this.resReplaceSubAreaList.length) {
              this.resReplaceSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.resReplaceManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resReplaceLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.resReplaceCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resReplaceBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.resReplaceEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resReplaceServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resReplaceSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resReplaceSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.resReplaceEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resReplaceHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resReplaceRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.resReplaceCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobReplaceSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.jobReplaceManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobReplaceCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
              this.jobReplaceCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobReplaceEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobReplaceServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobReplaceSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobReplaceEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobReplaceRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.jobReplaceJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobReplaceJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceJobCodeList = [
                ...this.masterDataService.dataJobCode,
              ];
              this.jobReplaceIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
            }
            break;

          case ROLE_LAYERS.REPLACE_ALL_CONFIG:
            if (!this.resReplaceAllSubAreaList.length) {
              this.resReplaceAllSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.resReplaceAllManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resReplaceAllLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.resReplaceAllCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resReplaceAllBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.resReplaceAllEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resReplaceAllServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resReplaceAllSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resReplaceAllSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.resReplaceAllEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resReplaceAllHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resReplaceAllRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.resReplaceAllCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobReplaceAllSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.jobReplaceAllManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobReplaceAllCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
              this.jobReplaceAllCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobReplaceAllEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobReplaceAllServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobReplaceAllSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobReplaceAllEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobReplaceAllRankList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.jobReplaceAllJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobReplaceAllJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceAllJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceAllJobCodeList = [
                ...this.masterDataService.dataJobCode,
              ];
              this.jobReplaceAllIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
            }
            break;

          case ROLE_LAYERS.ASSIGNMENT_CONFIG:
            if (!this.assignmentSubAreaList.length) {
              this.assignmentSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.assignmentManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.assignmentLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.assignmentCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.assignmentBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.assignmentEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.assignmentOperatingUnitList = [
                ...this.masterDataService.dataOperatingUnit,
              ];
              this.assignmentManagementUnitList = [
                ...this.masterDataService.dataManagementUnit,
              ];
              this.assignmentDepartmentList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.assignmentServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.assignmentSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.assignmentSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.assignmentLevelList = [
                ...this.masterDataService.dataActivityType,
              ];
              this.assignmentEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
            }
            break;

          case ROLE_LAYERS.APPROVAL_LAYER_CONFIG:
            this.jobAddJobCategoryList = [
              ...this.masterDataService.dataJobCategory,
            ];
            break;
          
          case ROLE_LAYERS.REPORT_CONFIG:
              this.assignmentManageReportList = [
                ...this.masterDataService.dataReport,
              ];
              this.getReportDetailsMasterVM(this.arrReportVMData);
          break;
  
        }
        if (
          !this.accordionOpenStatus[type] ||
          this.accordionOpenStatus[type] === false
        ) {
          this.sortMultiSelectBasedOnSelection(type);
        }
        this.accordionOpenStatus[type] = true;
      });
      this.sleep(5000).then(() => {
        this.spinner.hide();
      });
    }
  };

  masterData() {
    return new Promise<void>((resolve, reject) => {
      // In order to add caching of masterData using appMemService, uncomment the below lines.

      // const roleMasterData = this.appMemService.getData(
      //   DATA_KEY.ROLE_MASTER_DATA
      // );
      // if (roleMasterData && Object.keys(roleMasterData > 0)) {
      //   this.setControlsData(roleMasterData);
      //   this.roleTypes = roleMasterData.RoleTypeList;
      //   this.onChangeRoleType();
      //   resolve();
      // }
      this.getUserInstances();
      this.restService.getMasterData().subscribe(
        (data) => {
          // this.appMemService.setData(DATA_KEY.ROLE_MASTER_DATA, data); // Cache master data
          this.roleTypes = data.RoleTypeList;
          this.setControlsData(data); // Set values to controls
          this.onChangeRoleType();
          resolve();
        },
        (error) => {
          console.log('Error while fetching the master data', error);
          alert('Error while fetching the master data, please refresh');
          reject();
        },
        () => {
          console.log('Master data fetched');
        }
      );
    });
  }

  sortMultiSelectBasedOnSelection = (type) => {
    // Data sort based on the selection - Start
    switch (type) {
      case ROLE_LAYERS.REPORT_CONFIG:
        this.assignmentManageReportList = this.sortDataBasedOnSelectedItems(
          this.assignmentManageReportList,
          this.assignmentManageReportSelectedItems
        );
      case ROLE_LAYERS.ASSIGNMENT_CONFIG:
        this.assignmentSubAreaList = this.sortDataBasedOnSelectedItems(
          this.assignmentSubAreaList,
          this.assignmentSubAreaSelectedItems
        );
        this.assignmentManageCountryList = this.sortDataBasedOnSelectedItems(
          this.assignmentManageCountryList,
          this.assignmentManageCountrySelectedItems
        );
        this.assignmentLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.assignmentLegalEntityList,
          this.assignmentLegalEntitySelectedItems
        );
        this.assignmentCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.assignmentCompanyCodeList,
          this.assignmentCompanyCodeSelectedItems
        );
        this.assignmentEcLocationList = this.sortDataBasedOnSelectedItems(
          this.assignmentEcLocationList,
          this.assignmentEcLocationSelectedItems
        );

        this.assignmentOperatingUnitList = this.sortDataBasedOnSelectedItems(
          this.assignmentOperatingUnitList,
          this.assignmentOperatingUnitSelectedItems
        );
        this.assignmentManagementUnitList = this.sortDataBasedOnSelectedItems(
          this.assignmentManagementUnitList,
          this.assignmentManagementUnitSelectedItems
        );
        this.assignmentServiceLineList = this.sortDataBasedOnSelectedItems(
          this.assignmentServiceLineList,
          this.assignmentServiceLineSelectedItems
        );
        this.assignmentSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.assignmentSubServiceLineList,
          this.assignmentSubServiceLineSelectedItems
        );
        this.assignmentEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.assignmentEngCompetencyList,
          this.assignmentEngCompetencySelectedItems
        );
        this.assignmentDepartmentList = this.sortDataBasedOnSelectedItems(
          this.assignmentDepartmentList,
          this.assignmentDepartmentSelectedItems
        );
        this.assignmentLevelList = this.sortDataBasedOnSelectedItems(
          this.assignmentLevelList,
          this.assignmentLevelSelectedItems
        );
        break;

      case ROLE_LAYERS.VIEW_CONFIG:
        this.resViewSubAreaList = this.sortDataBasedOnSelectedItems(
          this.resViewSubAreaList,
          this.resViewSubAreaSelectedItems
        );
        this.resViewManageCountryList = this.sortDataBasedOnSelectedItems(
          this.resViewManageCountryList,
          this.resViewManageCountrySelectedItems
        );
        this.resViewLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.resViewLegalEntityList,
          this.resViewLegalEntitySelectedItems
        );
        this.resViewCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.resViewCompanyCodeList,
          this.resViewCompanyCodeSelectedItems
        );
        this.resViewBusinessUnitList = this.sortDataBasedOnSelectedItems(
          this.resViewBusinessUnitList,
          this.resViewBusinessUnitSelectedItems
        );
        this.resViewEcLocationList = this.sortDataBasedOnSelectedItems(
          this.resViewEcLocationList,
          this.resViewEcLocationSelectedItems
        );
        this.resViewServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resViewServiceLineList,
          this.resViewServiceLineSelectedItems
        );
        this.resViewSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resViewSubServiceLineList,
          this.resViewSubServiceLineSelectedItems
        );
        this.resViewSubManagementUnitList = this.sortDataBasedOnSelectedItems(
          this.resViewSubManagementUnitList,
          this.resViewSubManagementUnitSelectedItems
        );
        this.resViewEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.resViewEngCompetencyList,
          this.resViewEngCompetencySelectedItems
        );
        this.resViewHRDeptList = this.sortDataBasedOnSelectedItems(
          this.resViewHRDeptList,
          this.resViewHRDeptSelectedItems
        );

        this.resViewCostCenterList = this.sortDataBasedOnSelectedItems(
          this.resViewCostCenterList,
          this.resViewCostCenterSelectedItems
        );
        this.jobViewSubAreaList = this.sortDataBasedOnSelectedItems(
          this.jobViewSubAreaList,
          this.jobViewSubAreaSelectedItems
        );
        this.jobViewManageCountryList = this.sortDataBasedOnSelectedItems(
          this.jobViewManageCountryList,
          this.jobViewManageCountrySelectedItems
        );
        // this.jobViewLegalEntityList = this.sortDataBasedOnSelectedItems(
        //   this.jobViewLegalEntityList,
        //   this.jobViewLegalEntitySelectedItems
        // );
        this.jobViewCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.jobViewCompanyCodeList,
          this.jobViewCompanyCodeSelectedItems
        );

        this.jobViewEcLocationList = this.sortDataBasedOnSelectedItems(
          this.jobViewEcLocationList,
          this.jobViewEcLocationSelectedItems
        );
        this.jobViewServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobViewServiceLineList,
          this.jobViewServiceLineSelectedItems
        );
        this.jobViewSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobViewSubServiceLineList,
          this.jobViewSubServiceLineSelectedItems
        );
        this.jobViewEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.jobViewEngCompetencyList,
          this.jobViewEngCompetencySelectedItems
        );
        this.jobViewCostCenterList = this.sortDataBasedOnSelectedItems(
          this.jobViewCostCenterList,
          this.jobViewCostCenterSelectedItems
        );
        this.jobViewIncludeJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobViewIncludeJobCodeList,
          this.jobViewIncludeJobCodeSelectedItems
        );
        this.jobViewJobCategoryList = this.sortDataBasedOnSelectedItems(
          this.jobViewJobCategoryList,
          this.jobViewJobCategorySelectedItems
        );
        this.jobViewJobStatusList = this.sortDataBasedOnSelectedItems(
          this.jobViewJobStatusList,
          this.jobViewJobStatusSelectedItems
        );
        this.jobViewJobStatusBookingList = this.sortDataBasedOnSelectedItems(
          this.jobViewJobStatusBookingList,
          this.jobViewJobStatusBookingSelectedItems
        );
        this.jobViewJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobViewJobCodeList,
          this.jobViewJobCodeSelectedItems
        );
        this.jobViewJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobViewJobCodeList,
          this.jobViewJobCodeSelectedItems
        );
        break;

      case ROLE_LAYERS.EDIT_CONFIG:
        this.jobEditSubAreaList = this.sortDataBasedOnSelectedItems(
          this.jobEditSubAreaList,
          this.jobEditSubAreaSelectedItems
        );
        this.jobEditManageCountryList = this.sortDataBasedOnSelectedItems(
          this.jobEditManageCountryList,
          this.jobEditManageCountrySelectedItems
        );
        this.jobEditCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.jobEditCompanyCodeList,
          this.jobEditCompanyCodeSelectedItems
        );
        this.jobEditEcLocationList = this.sortDataBasedOnSelectedItems(
          this.jobEditEcLocationList,
          this.jobEditEcLocationSelectedItems
        );
        this.jobEditServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobEditServiceLineList,
          this.jobEditServiceLineSelectedItems
        );
        this.jobEditSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobEditSubServiceLineList,
          this.jobEditSubServiceLineSelectedItems
        );
        this.jobEditEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.jobEditEngCompetencyList,
          this.jobEditEngCompetencySelectedItems
        );
        this.jobEditCostCenterList = this.sortDataBasedOnSelectedItems(
          this.jobEditCostCenterList,
          this.jobEditCostCenterSelectedItems
        );
        this.jobEditIncludeJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobEditIncludeJobCodeList,
          this.jobEditIncludeJobCodeSelectedItems
        );
        this.jobEditJobCategoryList = this.sortDataBasedOnSelectedItems(
          this.jobEditJobCategoryList,
          this.jobEditJobCategorySelectedItems
        );
        this.jobEditJobStatusList = this.sortDataBasedOnSelectedItems(
          this.jobEditJobStatusList,
          this.jobEditJobStatusSelectedItems
        );
        this.jobEditJobStatusBookingList = this.sortDataBasedOnSelectedItems(
          this.jobEditJobStatusBookingList,
          this.jobEditJobStatusBookingSelectedItems
        );
        this.jobEditJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobEditJobCodeList,
          this.jobEditJobCodeSelectedItems
        );

        this.resEditSubAreaList = this.sortDataBasedOnSelectedItems(
          this.resEditSubAreaList,
          this.resEditSubAreaSelectedItems
        );
        this.resEditManageCountryList = this.sortDataBasedOnSelectedItems(
          this.resEditManageCountryList,
          this.resEditManageCountrySelectedItems
        );
        this.resEditLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.resEditLegalEntityList,
          this.resEditLegalEntitySelectedItems
        );
        this.resEditCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.resEditCompanyCodeList,
          this.resEditCompanyCodeSelectedItems
        );
        this.resEditBusinessUnitList = this.sortDataBasedOnSelectedItems(
          this.resEditBusinessUnitList,
          this.resEditBusinessUnitSelectedItems
        );
        this.resEditEcLocationList = this.sortDataBasedOnSelectedItems(
          this.resEditEcLocationList,
          this.resEditEcLocationSelectedItems
        );
        this.resEditServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resEditServiceLineList,
          this.resEditServiceLineSelectedItems
        );
        this.resEditSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resEditSubServiceLineList,
          this.resEditSubServiceLineSelectedItems
        );
        this.resEditSubManagementUnitList = this.sortDataBasedOnSelectedItems(
          this.resEditSubManagementUnitList,
          this.resEditSubManagementUnitSelectedItems
        );
        this.resEditEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.resEditEngCompetencyList,
          this.resEditEngCompetencySelectedItems
        );
        this.resEditHRDeptList = this.sortDataBasedOnSelectedItems(
          this.resEditHRDeptList,
          this.resEditHRDeptSelectedItems
        );
        this.resEditCostCenterList = this.sortDataBasedOnSelectedItems(
          this.resEditCostCenterList,
          this.resEditCostCenterSelectedItems
        );
        break;

      case ROLE_LAYERS.ADD_CONFIG:
        this.resAddSubAreaList = this.sortDataBasedOnSelectedItems(
          this.resAddSubAreaList,
          this.resAddSubAreaSelectedItems
        );
        this.resAddManageCountryList = this.sortDataBasedOnSelectedItems(
          this.resAddManageCountryList,
          this.resAddManageCountrySelectedItems
        );
        this.resAddLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.resAddLegalEntityList,
          this.resAddLegalEntitySelectedItems
        );
        this.resAddCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.resAddCompanyCodeList,
          this.resAddCompanyCodeSelectedItems
        );
        this.resAddBusinessUnitList = this.sortDataBasedOnSelectedItems(
          this.resAddBusinessUnitList,
          this.resAddBusinessUnitSelectedItems
        );
        this.resAddEcLocationList = this.sortDataBasedOnSelectedItems(
          this.resAddEcLocationList,
          this.resAddEcLocationSelectedItems
        );
        this.resAddServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resAddServiceLineList,
          this.resAddServiceLineSelectedItems
        );
        this.resAddSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resAddSubServiceLineList,
          this.resAddSubServiceLineSelectedItems
        );
        this.resAddSubManagementUnitList = this.sortDataBasedOnSelectedItems(
          this.resAddSubManagementUnitList,
          this.resAddSubManagementUnitSelectedItems
        );
        this.resAddEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.resAddEngCompetencyList,
          this.resAddEngCompetencySelectedItems
        );
        this.resAddHRDeptList = this.sortDataBasedOnSelectedItems(
          this.resAddHRDeptList,
          this.resAddHRDeptSelectedItems
        );
        this.resAddCostCenterList = this.sortDataBasedOnSelectedItems(
          this.resAddCostCenterList,
          this.resAddCostCenterSelectedItems
        );
        this.jobAddSubAreaList = this.sortDataBasedOnSelectedItems(
          this.jobAddSubAreaList,
          this.jobAddSubAreaSelectedItems
        );
        this.jobAddManageCountryList = this.sortDataBasedOnSelectedItems(
          this.jobAddManageCountryList,
          this.jobAddManageCountrySelectedItems
        );
        this.jobAddCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.jobAddCompanyCodeList,
          this.jobAddCompanyCodeSelectedItems
        );
        this.jobAddEcLocationList = this.sortDataBasedOnSelectedItems(
          this.jobAddEcLocationList,
          this.jobAddEcLocationSelectedItems
        );
        this.jobAddServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobAddServiceLineList,
          this.jobAddServiceLineSelectedItems
        );
        this.jobAddSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobAddSubServiceLineList,
          this.jobAddSubServiceLineSelectedItems
        );
        this.jobAddEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.jobAddEngCompetencyList,
          this.jobAddEngCompetencySelectedItems
        );
        this.jobAddIncludeJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobAddIncludeJobCodeList,
          this.jobAddIncludeJobCodeSelectedItems
        );
        this.jobAddCostCenterList = this.sortDataBasedOnSelectedItems(
          this.jobAddCostCenterList,
          this.jobAddCostCenterSelectedItems
        );
        this.jobAddJobCategoryList = this.sortDataBasedOnSelectedItems(
          this.jobAddJobCategoryList,
          this.jobAddJobCategorySelectedItems
        );
        this.jobAddJobStatusList = this.sortDataBasedOnSelectedItems(
          this.jobAddJobStatusList,
          this.jobAddJobStatusSelectedItems
        );
        this.jobAddJobStatusBookingList = this.sortDataBasedOnSelectedItems(
          this.jobAddJobStatusBookingList,
          this.jobAddJobStatusBookingSelectedItems
        );
        this.jobAddJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobAddJobCodeList,
          this.jobAddJobCodeSelectedItems
        );
        break;

      case ROLE_LAYERS.DELETE_CONFIG:
        this.resDeleteSubAreaList = this.sortDataBasedOnSelectedItems(
          this.resDeleteSubAreaList,
          this.resDeleteSubAreaSelectedItems
        );
        this.resDeleteManageCountryList = this.sortDataBasedOnSelectedItems(
          this.resDeleteManageCountryList,
          this.resDeleteManageCountrySelectedItems
        );
        this.resDeleteLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.resDeleteLegalEntityList,
          this.resDeleteLegalEntitySelectedItems
        );
        this.resDeleteCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.resDeleteCompanyCodeList,
          this.resDeleteCompanyCodeSelectedItems
        );
        this.resDeleteBusinessUnitList = this.sortDataBasedOnSelectedItems(
          this.resDeleteBusinessUnitList,
          this.resDeleteBusinessUnitSelectedItems
        );
        this.resDeleteEcLocationList = this.sortDataBasedOnSelectedItems(
          this.resDeleteEcLocationList,
          this.resDeleteEcLocationSelectedItems
        );
        this.resDeleteServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resDeleteServiceLineList,
          this.resDeleteServiceLineSelectedItems
        );
        this.resDeleteSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resDeleteSubServiceLineList,
          this.resDeleteSubServiceLineSelectedItems
        );
        this.resDeleteSubManagementUnitList = this.sortDataBasedOnSelectedItems(
          this.resDeleteSubManagementUnitList,
          this.resDeleteSubManagementUnitSelectedItems
        );
        this.resDeleteEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.resDeleteEngCompetencyList,
          this.resDeleteEngCompetencySelectedItems
        );
        this.resDeleteHRDeptList = this.sortDataBasedOnSelectedItems(
          this.resDeleteHRDeptList,
          this.resDeleteHRDeptSelectedItems
        );
        this.resDeleteCostCenterList = this.sortDataBasedOnSelectedItems(
          this.resDeleteCostCenterList,
          this.resDeleteCostCenterSelectedItems
        );
        this.jobDeleteSubAreaList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteSubAreaList,
          this.jobDeleteSubAreaSelectedItems
        );
        this.jobDeleteManageCountryList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteManageCountryList,
          this.jobDeleteManageCountrySelectedItems
        );
        this.jobDeleteCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteCompanyCodeList,
          this.jobDeleteCompanyCodeSelectedItems
        );
        this.jobDeleteEcLocationList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteEcLocationList,
          this.jobDeleteEcLocationSelectedItems
        );
        this.jobDeleteServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteServiceLineList,
          this.jobDeleteServiceLineSelectedItems
        );
        this.jobDeleteSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteSubServiceLineList,
          this.jobDeleteSubServiceLineSelectedItems
        );
        this.jobDeleteEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteEngCompetencyList,
          this.jobDeleteEngCompetencySelectedItems
        );
        this.jobDeleteIncludeJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteIncludeJobCodeList,
          this.jobDeleteIncludeJobCodeSelectedItems
        );
        this.jobDeleteCostCenterList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteCostCenterList,
          this.jobDeleteCostCenterSelectedItems
        );
        this.jobDeleteJobCategoryList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteJobCategoryList,
          this.jobDeleteJobCategorySelectedItems
        );
        this.jobDeleteJobStatusList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteJobStatusList,
          this.jobDeleteJobStatusSelectedItems
        );
        this.jobDeleteJobStatusBookingList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteJobStatusBookingList,
          this.jobDeleteJobStatusBookingSelectedItems
        );
        this.jobDeleteJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobDeleteJobCodeList,
          this.jobDeleteJobCodeSelectedItems
        );
        break;

      case ROLE_LAYERS.REPLACE_CONFIG:
        this.resReplaceSubAreaList = this.sortDataBasedOnSelectedItems(
          this.resReplaceSubAreaList,
          this.resReplaceSubAreaSelectedItems
        );
        this.resReplaceManageCountryList = this.sortDataBasedOnSelectedItems(
          this.resReplaceManageCountryList,
          this.resReplaceManageCountrySelectedItems
        );
        this.resReplaceLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.resReplaceLegalEntityList,
          this.resReplaceLegalEntitySelectedItems
        );
        this.resReplaceCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.resReplaceCompanyCodeList,
          this.resReplaceCompanyCodeSelectedItems
        );
        this.resReplaceBusinessUnitList = this.sortDataBasedOnSelectedItems(
          this.resReplaceBusinessUnitList,
          this.resReplaceBusinessUnitSelectedItems
        );
        this.resReplaceEcLocationList = this.sortDataBasedOnSelectedItems(
          this.resReplaceEcLocationList,
          this.resReplaceEcLocationSelectedItems
        );
        this.resReplaceServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resReplaceServiceLineList,
          this.resReplaceServiceLineSelectedItems
        );
        this.resReplaceSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resReplaceSubServiceLineList,
          this.resReplaceSubServiceLineSelectedItems
        );
        this.resReplaceSubManagementUnitList =
          this.sortDataBasedOnSelectedItems(
            this.resReplaceSubManagementUnitList,
            this.resReplaceSubManagementUnitSelectedItems
          );
        this.resReplaceEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.resReplaceEngCompetencyList,
          this.resReplaceEngCompetencySelectedItems
        );
        this.resReplaceHRDeptList = this.sortDataBasedOnSelectedItems(
          this.resReplaceHRDeptList,
          this.resReplaceHRDeptSelectedItems
        );
        this.resReplaceCostCenterList = this.sortDataBasedOnSelectedItems(
          this.resReplaceCostCenterList,
          this.resReplaceCostCenterSelectedItems
        );
        this.jobReplaceSubAreaList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceSubAreaList,
          this.jobReplaceSubAreaSelectedItems
        );
        this.jobReplaceManageCountryList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceManageCountryList,
          this.jobReplaceManageCountrySelectedItems
        );
        this.jobReplaceCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceCompanyCodeList,
          this.jobReplaceCompanyCodeSelectedItems
        );
        this.jobReplaceEcLocationList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceEcLocationList,
          this.jobReplaceEcLocationSelectedItems
        );
        this.jobReplaceServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceServiceLineList,
          this.jobReplaceServiceLineSelectedItems
        );
        this.jobReplaceSubServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceSubServiceLineList,
          this.jobReplaceSubServiceLineSelectedItems
        );
        this.jobReplaceEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceEngCompetencyList,
          this.jobReplaceEngCompetencySelectedItems
        );
        this.jobReplaceIncludeJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceIncludeJobCodeList,
          this.jobReplaceIncludeJobCodeSelectedItems
        );
        this.jobReplaceCostCenterList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceCostCenterList,
          this.jobReplaceCostCenterSelectedItems
        );
        this.jobReplaceJobCategoryList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceJobCategoryList,
          this.jobReplaceJobCategorySelectedItems
        );
        this.jobReplaceJobStatusList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceJobStatusList,
          this.jobReplaceJobStatusSelectedItems
        );
        this.jobReplaceJobStatusBookingList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceJobStatusBookingList,
          this.jobReplaceJobStatusBookingSelectedItems
        );
        this.jobReplaceJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceJobCodeList,
          this.jobReplaceJobCodeSelectedItems
        );
        break;

      case ROLE_LAYERS.REPLACE_ALL_CONFIG:
        this.resReplaceAllSubAreaList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllSubAreaList,
          this.resReplaceAllSubAreaSelectedItems
        );
        this.resReplaceAllManageCountryList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllManageCountryList,
          this.resReplaceAllManageCountrySelectedItems
        );
        this.resReplaceAllLegalEntityList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllLegalEntityList,
          this.resReplaceAllLegalEntitySelectedItems
        );
        this.resReplaceAllCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllCompanyCodeList,
          this.resReplaceAllCompanyCodeSelectedItems
        );
        this.resReplaceAllBusinessUnitList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllBusinessUnitList,
          this.resReplaceAllBusinessUnitSelectedItems
        );
        this.resReplaceAllEcLocationList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllEcLocationList,
          this.resReplaceAllEcLocationSelectedItems
        );
        this.resReplaceAllServiceLineList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllServiceLineList,
          this.resReplaceAllServiceLineSelectedItems
        );
        this.resReplaceAllSubServiceLineList =
          this.sortDataBasedOnSelectedItems(
            this.resReplaceAllSubServiceLineList,
            this.resReplaceAllSubServiceLineSelectedItems
          );
        this.resReplaceAllSubManagementUnitList =
          this.sortDataBasedOnSelectedItems(
            this.resReplaceAllSubManagementUnitList,
            this.resReplaceAllSubManagementUnitSelectedItems
          );
        this.resReplaceAllEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllEngCompetencyList,
          this.resReplaceAllEngCompetencySelectedItems
        );
        this.resReplaceAllHRDeptList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllHRDeptList,
          this.resReplaceAllHRDeptSelectedItems
        );
        this.resReplaceAllCostCenterList = this.sortDataBasedOnSelectedItems(
          this.resReplaceAllCostCenterList,
          this.resReplaceAllCostCenterSelectedItems
        );

        this.jobReplaceAllSubAreaList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllSubAreaList,
          this.jobReplaceAllSubAreaSelectedItems
        );
        this.jobReplaceAllManageCountryList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllManageCountryList,
          this.jobReplaceAllManageCountrySelectedItems
        );
        this.jobReplaceAllCompanyCodeList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllCompanyCodeList,
          this.jobReplaceAllCompanyCodeSelectedItems
        );
        this.jobReplaceAllEcLocationList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllEcLocationList,
          this.jobReplaceAllEcLocationSelectedItems
        );
        this.jobReplaceAllServiceLineList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllServiceLineList,
          this.jobReplaceAllServiceLineSelectedItems
        );
        this.jobReplaceAllSubServiceLineList =
          this.sortDataBasedOnSelectedItems(
            this.jobReplaceAllSubServiceLineList,
            this.jobReplaceAllSubServiceLineSelectedItems
          );
        this.jobReplaceAllEngCompetencyList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllEngCompetencyList,
          this.jobReplaceAllEngCompetencySelectedItems
        );
        this.jobReplaceAllCostCenterList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllCostCenterList,
          this.jobReplaceAllCostCenterSelectedItems
        );
        this.jobReplaceAllJobCategoryList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllJobCategoryList,
          this.jobReplaceAllJobCategorySelectedItems
        );
        this.jobReplaceAllJobStatusList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllJobStatusList,
          this.jobReplaceAllJobStatusSelectedItems
        );
        this.jobReplaceAllJobStatusBookingList =
          this.sortDataBasedOnSelectedItems(
            this.jobReplaceAllJobStatusBookingList,
            this.jobReplaceAllJobStatusBookingSelectedItems
          );
        this.jobReplaceAllJobCodeList = this.sortDataBasedOnSelectedItems(
          this.jobReplaceAllJobCodeList,
          this.jobReplaceAllJobCodeSelectedItems
        );
        this.jobReplaceAllIncludeJobCodeList =
          this.sortDataBasedOnSelectedItems(
            this.jobReplaceAllIncludeJobCodeList,
            this.jobReplaceAllIncludeJobCodeSelectedItems
          );
        break;
    }
  };

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  openConfirmationModal(template, confirmationAction) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.confirmationClickAction = confirmationAction;
    this.modalRef = this.modalService.show(template, this.modalOption);
  }

  //#endregion

  //#region Form Control Event
  cancel(template, confirmationAction) {
    this.openConfirmationModal(template, confirmationAction);
  }

  onConfirmAction() {
    this.modalRef.hide();
    if (this.confirmationClickAction.toLocaleLowerCase() == 'reset') {
      this.clearControls();
    } else {
      this.restService.cancelClick();
    }
  }

  resetEnableGhostBooking() {
    this.makeDirty();
    this.resetGhostBookingActionCheckBoxes();
  }

  resetGhostBookingActionCheckBoxes() {
    this.bookingDisabledGhostView = true;
    this.bookingDisabledGhostEdit = true;
    this.bookingDisabledGhostDelete = true;
    this.bookingDisabledGhostCopy = true;
    this.bookingDisabledGhostReplace = true;
  }

  onSubmit() {
    //debugger;
    if (!this.dirtyFlag || this.formGroup.invalid || this.isExistsAccessRole) {
    //  window.scroll(0, 0);
    this.onScroll.emit();
      return;
    }
    if (this.accessRoleName.trim() === '') {
      this.isExistsAccessRole = true;
      this.errorMessage = 'Role Name is required';
      // window.scroll(0, 0);
      this.onScroll.emit();
      return;
    }

    if (
      !this.InstanceEnableAddBookingIV &&
      this.selectedHomeBasedInstance == null
    ) {
      this.isHomeRetainNotSelected = true;
      this.errorMessage = 'Please Select Home-Based Retain Instance';
      // window.scroll(0, 0);
      this.onScroll.emit();
      return;
    }

    this.spinner.show();
    this.buttonText = 'Please wait..';
    this.role = new RoleVM();
    let assingmentDto = new AssignmentConfigurationDto();
    let resAddDto = new ResourceAddConfigurationDto();
    let jobAddDto = new JobAddConfigurationDto();
    let resDeleteDto = new ResourceDeleteConfigurationDto();
    let jobDeleteDto = new JobDeleteConfigurationDto();
    let resReplaceDto = new ResourceReplaceConfigurationDto();
    let jobReplaceDto = new JobReplaceConfigurationDto();
    let resReplaceAllDto = new ResourceReplaceAllConfigurationDto();
    let jobReplaceAllDto = new JobReplaceAllConfigurationDto();
    let resEditDto = new ResourceEditConfigurationDto();
    let jobEditDto = new JobEditConfigurationDto();
    let resViewDto = new ResourceViewConfigurationDto();
    let jobViewDto = new JobViewConfigurationDto();
    let bookingConfigurationDto = new BookingConfigurationDto();

    if (this.actionSelected == ActionNameEnum.Copy) {
      this.role.R_ID = 0;
    } else if (
      this.actionSelected == ActionNameEnum.Edit ||
      this.actionSelected == ActionNameEnum.View
    ) {
      this.role.R_ID = +this.RoleId;
    }
    this.role.R_RT_ID = +this.selectedRoleType;
    this.role.R_Name = this.accessRoleName;
    this.role.R_Priority = this.selectedPriority;
    this.role.R_Comments = this.remark;
    this.role.R_View = this.selectedRoleView;
    this.role.R_Delegate = this.selectedDelegate;
    this.role.R_RELinkConfig = this.resEditLink;
    this.role.R_RADLinkConfig = this.resAddLink; // Add Config
    this.role.R_RVLinkConfig = this.resViewLink;
    this.role.R_JELinkConfig = this.jobEditLink;
    this.role.R_JADLinkConfig = this.jobAddLink; // Add Config
    this.role.R_JVLinkConfig = this.jobViewLink;
    this.role.R_RALinkConfig = this.assignmentLink;
    this.role.R_ModifiedBy = +sessionStorage.getItem('loggedin_resourceid');
    this.role.R_CreatedBy = +sessionStorage.getItem('loggedin_resourceid');
    this.role.R_IsActive = this.selectedRoleIsActive;
    this.role.R_CoWorker = this.selectedCoworkers;
    this.role.R_Enable_JobAssignDescr = this.selectedJobAssignment;
    this.role.R_Enable_CompDescr = this.selectedComponent;
    this.role.R_Expand_Wallchart = this.selectedExpandWallchart
  
    this.role.R_Experience_Manager = this.selectedExperienceManager;
    this.role.R_MUltipleInstance = this.isAllretainInstReq;
    this.role.R_Ghost = this.disableActionsGhostBooking;
    this.role.R_OverAllocation = this.overallocation;
    this.role.R_Unconfirmed = this.unconfirmed;
    this.role.R_IsReqdApproval = this.isApproverReq;
    this.role.R_I_ID = this.isAllretainInstReq ? null : this.selectedInstance;
    this.role.R_InstEnable_IV = this.roleIndividualView;
    this.role.R_InstEnable_EV = this.roleEngagementView;
    this.role.R_InstEnable_TV = this.roleTeamView;
    this.role.R_PreviewSubmit = this.previewSubmit;
    this.role.R_InstEnable_AddBooking = this.InstanceEnableAddBookingIV;
    this.role.R_Home_InstanceID = this.selectedHomeBasedInstance;

    assingmentDto.AssignmentSubAreas = this.assignmentSubAreaSelectedItems;
    assingmentDto.AssignmentCompetencies =
      this.assignmentEngCompetencySelectedItems;
    assingmentDto.AssignmentSubServiceLines =
      this.assignmentSubServiceLineSelectedItems;
    assingmentDto.AssignmentManagerialCountries =
      this.assignmentManageCountrySelectedItems;
     

    assingmentDto.AssignmentLegalEntities =
      this.assignmentLegalEntitySelectedItems;
    assingmentDto.AssignmentCompanyCodes =
      this.assignmentCompanyCodeSelectedItems;
    assingmentDto.AssignmentServiceLines =
      this.assignmentServiceLineSelectedItems;

    // assingmentDto.AssignmentRanks = this.assignmentRankSelectedItems;
    assingmentDto.ActivityTypes = this.assignmentLevelSelectedItems;
    // assingmentDto.AssignmentBusinessUnits =
    //   this.assignmentBusinessUnitSelectedItems;
    assingmentDto.AssignmentEconomicLocations =
      this.assignmentEcLocationSelectedItems;
    assingmentDto.AssignmentRanks = this.assignmentRankSelectedItems;
    assingmentDto.RAR_ISACTIVE = this.assignmentIsActive;
    assingmentDto.AssignmentOperatingUnits =
      this.assignmentOperatingUnitSelectedItems;
    assingmentDto.AssignmentManageUnits =
      this.assignmentManagementUnitSelectedItems;
    assingmentDto.AssignmentDepartment = this.assignmentDepartmentSelectedItems;
    // Start Add Configuration
    resAddDto.ResAddSubAreas = this.resAddSubAreaSelectedItems;
    resAddDto.ResAddSubManageUnits = this.resAddSubManagementUnitSelectedItems;
    resAddDto.ResAddCompetencies = this.resAddEngCompetencySelectedItems;
    resAddDto.ResAddDepartments = this.resAddHRDeptSelectedItems;
    resAddDto.ResAddCostCenters = this.resAddCostCenterSelectedItems;
    resAddDto.ResAddSubServiceLines = this.resAddSubServiceLineSelectedItems;
    resAddDto.ResAddManagerialCountries = this.resAddManageCountrySelectedItems;
    resAddDto.ResAddLegalEntities = this.resAddLegalEntitySelectedItems;
    resAddDto.ResAddCompanyCodes = this.resAddCompanyCodeSelectedItems;
    resAddDto.ResAddServiceLines = this.resAddServiceLineSelectedItems;
    resAddDto.ResAddBusinessUnits = this.resAddBusinessUnitSelectedItems;
    resAddDto.ResAddEconomicLocations = this.resAddEcLocationSelectedItems;
    resAddDto.RRAC_RInactive = this.resAddIsActive;
    resAddDto.RRAC_ISDisabled = this.resAddIsDisabled;
    resAddDto.RRAC_ISLikeEdit = this.resAddIsLikeEdit;
    resAddDto.RRAC_IV_Disabled = this.resAddIndividualView;
    resAddDto.RRAC_EV_Disabled = this.resAddEngagementView;

    jobAddDto.JobAddSubAreas = this.jobAddSubAreaSelectedItems;
    jobAddDto.JobAddCompetencies = this.jobAddEngCompetencySelectedItems;
    jobAddDto.JobAddSubServiceLines = this.jobAddSubServiceLineSelectedItems;
    jobAddDto.JobAddManagerialCountries = this.jobAddManageCountrySelectedItems;
    jobAddDto.JobAddCompanyCodes = this.jobAddCompanyCodeSelectedItems;
    jobAddDto.JobAddServiceLines = this.jobAddServiceLineSelectedItems;
    jobAddDto.JobAddEconomicLocations = this.jobAddEcLocationSelectedItems;

    jobAddDto.JobAddJobCategories = this.jobAddJobCategorySelectedItems;
    jobAddDto.JobAddJobCode = this.jobAddJobCodeSelectedItems;
    jobAddDto.JobAddIncludeJobCode = this.jobAddIncludeJobCodeSelectedItems;
    jobAddDto.JobAddCostCenters = this.jobAddCostCenterSelectedItems;
    jobAddDto.JobAddJobStatuses = this.jobAddJobStatusSelectedItems;
    jobAddDto.JobAddJobStatusBookings =
      this.jobAddJobStatusBookingSelectedItems;
    jobAddDto.RJAC_Learning = this.jobAddIsTR;
    jobAddDto.RJAC_ISDisabled = this.jobAddIsDisabled;
    jobAddDto.RJAC_ISLikeEdit = this.jobAddIsLikeEdit;
    jobAddDto.RJAC_IsPended = this.jobAddIsPended;
    jobAddDto.RJAC_IV_Disabled = this.jobAddIndividualView;
    jobAddDto.RJAC_EV_Disabled = this.jobAddEngagementView;
    // END Add Configuration

    // Start Delete  Configuration
    resDeleteDto.ResDeleteSubAreas = this.resDeleteSubAreaSelectedItems;
    resDeleteDto.ResDeleteSubManageUnits =
      this.resDeleteSubManagementUnitSelectedItems;
    resDeleteDto.ResDeleteCompetencies =
      this.resDeleteEngCompetencySelectedItems;
    resDeleteDto.ResDeleteDepartments = this.resDeleteHRDeptSelectedItems;
    resDeleteDto.ResDeleteCostCenters = this.resDeleteCostCenterSelectedItems;
    resDeleteDto.ResDeleteSubServiceLines =
      this.resDeleteSubServiceLineSelectedItems;
    resDeleteDto.ResDeleteManagerialCountries =
      this.resDeleteManageCountrySelectedItems;
    resDeleteDto.ResDeleteLegalEntities =
      this.resDeleteLegalEntitySelectedItems;
    resDeleteDto.ResDeleteCompanyCodes = this.resDeleteCompanyCodeSelectedItems;
    resDeleteDto.ResDeleteServiceLines = this.resDeleteServiceLineSelectedItems;
    resDeleteDto.ResDeleteBusinessUnits =
      this.resDeleteBusinessUnitSelectedItems;
    resDeleteDto.ResDeleteEconomicLocations =
      this.resDeleteEcLocationSelectedItems;
    resDeleteDto.RRDC_RInactive = this.resDeleteIsActive;
    resDeleteDto.RRDC_ISDisabled = this.resDeleteIsDisabled;
    resDeleteDto.RRDC_ISLikeEdit = this.resDeleteIsLikeEdit;
    resDeleteDto.RRDC_IV_Disabled = this.resDeleteIndividualView;
    resDeleteDto.RRDC_EV_Disabled = this.resDeleteEngagementView;

    jobDeleteDto.JobDeleteSubAreas = this.jobDeleteSubAreaSelectedItems;
    jobDeleteDto.JobDeleteCompetencies =
      this.jobDeleteEngCompetencySelectedItems;
    jobDeleteDto.JobDeleteSubServiceLines =
      this.jobDeleteSubServiceLineSelectedItems;
    jobDeleteDto.JobDeleteManagerialCountries =
      this.jobDeleteManageCountrySelectedItems;
    jobDeleteDto.JobDeleteCompanyCodes = this.jobDeleteCompanyCodeSelectedItems;
    jobDeleteDto.JobDeleteServiceLines = this.jobDeleteServiceLineSelectedItems;
    jobDeleteDto.JobDeleteEconomicLocations =
      this.jobDeleteEcLocationSelectedItems;
    jobDeleteDto.JobDeleteJobCategories =
      this.jobDeleteJobCategorySelectedItems;
    jobDeleteDto.JobDeleteJobCode = this.jobDeleteJobCodeSelectedItems;
    jobDeleteDto.JobDeleteIncludeJobCode =
      this.jobDeleteIncludeJobCodeSelectedItems;
    jobDeleteDto.JobDeleteCostCenters = this.jobDeleteCostCenterSelectedItems;
    jobDeleteDto.JobDeleteJobStatuses = this.jobDeleteJobStatusSelectedItems;
    jobDeleteDto.JobDeleteJobStatusBookings =
      this.jobDeleteJobStatusBookingSelectedItems;
    jobDeleteDto.RJDC_Learning = this.jobDeleteIsTR;
    jobDeleteDto.RJDC_ISDisabled = this.jobDeleteIsDisabled;
    jobDeleteDto.RJDC_ISLikeEdit = this.jobDeleteIsLikeEdit;
    jobDeleteDto.RJDC_IsPended = this.jobDeleteIsPended;
    jobDeleteDto.RJDC_IV_Disabled = this.jobDeleteIndividualView;
    jobDeleteDto.RJDC_EV_Disabled = this.jobDeleteEngagementView;
    // END Delete Configuration

    // Start Replace  Configuration
    resReplaceDto.ResReplaceSubAreas = this.resReplaceSubAreaSelectedItems;
    resReplaceDto.ResReplaceSubManageUnits =
      this.resReplaceSubManagementUnitSelectedItems;
    resReplaceDto.ResReplaceDepartments = this.resReplaceHRDeptSelectedItems;
    resReplaceDto.ResReplaceCostCenters =
      this.resReplaceCostCenterSelectedItems;
    resReplaceDto.ResReplaceSubServiceLines =
      this.resReplaceSubServiceLineSelectedItems;
    resReplaceDto.ResReplaceCompetencies =
      this.resReplaceEngCompetencySelectedItems;
    resReplaceDto.ResReplaceManagerialCountries =
      this.resReplaceManageCountrySelectedItems;
    resReplaceDto.ResReplaceLegalEntities =
      this.resReplaceLegalEntitySelectedItems;
    resReplaceDto.ResReplaceCompanyCodes =
      this.resReplaceCompanyCodeSelectedItems;
    resReplaceDto.ResReplaceServiceLines =
      this.resReplaceServiceLineSelectedItems;
    resReplaceDto.ResReplaceBusinessUnits =
      this.resReplaceBusinessUnitSelectedItems;
    resReplaceDto.ResReplaceEconomicLocations =
      this.resReplaceEcLocationSelectedItems;
    resReplaceDto.RRRC_RInactive = this.resReplaceIsActive;
    resReplaceDto.RRRC_ISDisabled = this.resReplaceIsDisabled;
    resReplaceDto.RRRC_ISLikeEdit = this.resReplaceIsLikeEdit;
    resReplaceDto.RRRC_IV_Disabled = this.resReplaceIndividualView;
    resReplaceDto.RRRC_EV_Disabled = this.resReplaceEngagementView;

    jobReplaceDto.JobReplaceSubAreas = this.jobReplaceSubAreaSelectedItems;
    jobReplaceDto.JobReplaceCompetencies =
      this.jobReplaceEngCompetencySelectedItems;
    jobReplaceDto.JobReplaceSubServiceLines =
      this.jobReplaceSubServiceLineSelectedItems;
    jobReplaceDto.JobReplaceManagerialCountries =
      this.jobReplaceManageCountrySelectedItems;
    jobReplaceDto.JobReplaceCompanyCodes =
      this.jobReplaceCompanyCodeSelectedItems;
    jobReplaceDto.JobReplaceServiceLines =
      this.jobReplaceServiceLineSelectedItems;
    jobReplaceDto.JobReplaceEconomicLocations =
      this.jobReplaceEcLocationSelectedItems;
    jobReplaceDto.JobReplaceJobCategories =
      this.jobReplaceJobCategorySelectedItems;
    jobReplaceDto.JobReplaceJobCode = this.jobReplaceJobCodeSelectedItems;
    jobReplaceDto.JobReplaceIncludeJobCode =
      this.jobReplaceIncludeJobCodeSelectedItems;
    jobReplaceDto.JobReplaceCostCenters =
      this.jobReplaceCostCenterSelectedItems;
    jobReplaceDto.JobReplaceJobStatuses = this.jobReplaceJobStatusSelectedItems;
    jobReplaceDto.JobReplaceJobStatusBookings =
      this.jobReplaceJobStatusBookingSelectedItems;
    jobReplaceDto.RJRC_Learning = this.jobReplaceIsTR;
    jobReplaceDto.RJRC_ISDisabled = this.jobReplaceIsDisabled;
    jobReplaceDto.RJRC_ISLikeEdit = this.jobReplaceIsLikeEdit;
    jobReplaceDto.RJRC_IsPended = this.jobReplaceIsPended;
    jobReplaceDto.RJRC_IV_Disabled = this.jobReplaceIndividualView;
    jobReplaceDto.RJRC_EV_Disabled = this.jobReplaceEngagementView;
    // END Replace Configuration

    // Start Replace All  Configuration
    resReplaceAllDto.ResReplaceAllSubAreas =
      this.resReplaceAllSubAreaSelectedItems;
    resReplaceAllDto.ResReplaceAllSubManageUnits =
      this.resReplaceAllSubManagementUnitSelectedItems;
    resReplaceAllDto.ResReplaceAllCompetencies =
      this.resReplaceAllEngCompetencySelectedItems;
    resReplaceAllDto.ResReplaceAllDepartments =
      this.resReplaceAllHRDeptSelectedItems;
    resReplaceAllDto.ResReplaceAllCostCenters =
      this.resReplaceAllCostCenterSelectedItems;
    resReplaceAllDto.ResReplaceAllSubServiceLines =
      this.resReplaceAllSubServiceLineSelectedItems;
    resReplaceAllDto.ResReplaceAllManagerialCountries =
      this.resReplaceAllManageCountrySelectedItems;
    resReplaceAllDto.ResReplaceAllLegalEntities =
      this.resReplaceAllLegalEntitySelectedItems;
    resReplaceAllDto.ResReplaceAllCompanyCodes =
      this.resReplaceAllCompanyCodeSelectedItems;
    resReplaceAllDto.ResReplaceAllServiceLines =
      this.resReplaceAllServiceLineSelectedItems;
    resReplaceAllDto.ResReplaceAllBusinessUnits =
      this.resReplaceAllBusinessUnitSelectedItems;
    resReplaceAllDto.ResReplaceAllEconomicLocations =
      this.resReplaceAllEcLocationSelectedItems;
    resReplaceAllDto.RRRAC_RInactive = this.resReplaceAllIsActive;
    resReplaceAllDto.RRRAC_ISDisabled = this.resReplaceAllIsDisabled;
    resReplaceAllDto.RRRAC_ISLikeEdit = this.resReplaceAllIsLikeEdit;
    resReplaceAllDto.RRRAC_IV_Disabled = this.resReplaceAllIndividualView;
    resReplaceAllDto.RRRAC_EV_Disabled = this.resReplaceAllEngagementView;

    jobReplaceAllDto.JobReplaceAllSubAreas =
      this.jobReplaceAllSubAreaSelectedItems;
    jobReplaceAllDto.JobReplaceAllCompetencies =
      this.jobReplaceAllEngCompetencySelectedItems;
    jobReplaceAllDto.JobReplaceAllSubServiceLines =
      this.jobReplaceAllSubServiceLineSelectedItems;
    jobReplaceAllDto.JobReplaceAllManagerialCountries =
      this.jobReplaceAllManageCountrySelectedItems;
    jobReplaceAllDto.JobReplaceAllCompanyCodes =
      this.jobReplaceAllCompanyCodeSelectedItems;
    jobReplaceAllDto.JobReplaceAllServiceLines =
      this.jobReplaceAllServiceLineSelectedItems;
    jobReplaceAllDto.JobReplaceAllEconomicLocations =
      this.jobReplaceAllEcLocationSelectedItems;
    jobReplaceAllDto.JobReplaceAllJobCategories =
      this.jobReplaceAllJobCategorySelectedItems;
    jobReplaceAllDto.JobReplaceAllJobCode =
      this.jobReplaceAllJobCodeSelectedItems;
    jobReplaceAllDto.JobReplaceAllIncludeJobCode =
      this.jobReplaceAllIncludeJobCodeSelectedItems;
    jobReplaceAllDto.JobReplaceAllCostCenters =
      this.jobReplaceAllCostCenterSelectedItems;
    jobReplaceAllDto.JobReplaceAllJobStatuses =
      this.jobReplaceAllJobStatusSelectedItems;
    jobReplaceAllDto.JobReplaceAllJobStatusBookings =
      this.jobReplaceAllJobStatusBookingSelectedItems;
    jobReplaceAllDto.RJRAC_Learning = this.jobReplaceAllIsTR;
    jobReplaceAllDto.RJRAC_ISDisabled = this.jobReplaceAllIsDisabled;
    jobReplaceAllDto.RJRAC_ISLikeEdit = this.jobReplaceAllIsLikeEdit;
    jobReplaceAllDto.RJRAC_IsPended = this.jobReplaceAllIsPended;
    jobReplaceAllDto.RJRAC_IV_Disabled = this.jobReplaceAllIndividualView;
    jobReplaceAllDto.RJRAC_EV_Disabled = this.jobReplaceAllEngagementView;
    // END Replace All Configuration
    resEditDto.ResEditSubAreas = this.resEditSubAreaSelectedItems;
    resEditDto.ResEditSubManageUnits =
      this.resEditSubManagementUnitSelectedItems;
    resEditDto.ResEditCompetencies = this.resEditEngCompetencySelectedItems;
    resEditDto.ResEditDepartments = this.resEditHRDeptSelectedItems;
    resEditDto.ResEditCostCenters = this.resEditCostCenterSelectedItems;
    resEditDto.ResEditSubServiceLines = this.resEditSubServiceLineSelectedItems;
    resEditDto.ResEditManagerialCountries =
      this.resEditManageCountrySelectedItems;
    resEditDto.ResEditLegalEntities = this.resEditLegalEntitySelectedItems;
    resEditDto.ResEditCompanyCodes = this.resEditCompanyCodeSelectedItems;
    resEditDto.ResEditServiceLines = this.resEditServiceLineSelectedItems;
    resEditDto.ResEditBusinessUnits = this.resEditBusinessUnitSelectedItems;
    resEditDto.ResEditEconomicLocations = this.resEditEcLocationSelectedItems;
    resEditDto.RREC_RInactive = this.resEditIsActive;
    resEditDto.RREC_ISDisabled = this.resEditIsDisabled;
    resEditDto.RREC_IV_Disabled = this.resEditIndividualView;
    resEditDto.RREC_EV_Disabled = this.resEditEngagementView;

    jobEditDto.JobEditSubAreas = this.jobEditSubAreaSelectedItems;
    jobEditDto.JobEditCompetencies = this.jobEditEngCompetencySelectedItems;
    jobEditDto.JobEditCostCenters = this.jobEditCostCenterSelectedItems;
    jobEditDto.JobEditSubServiceLines = this.jobEditSubServiceLineSelectedItems;
    jobEditDto.JobEditManagerialCountries =
      this.jobEditManageCountrySelectedItems;
    jobEditDto.JobEditCompanyCodes = this.jobEditCompanyCodeSelectedItems;
    jobEditDto.JobEditServiceLines = this.jobEditServiceLineSelectedItems;
    jobEditDto.JobEditEconomicLocations = this.jobEditEcLocationSelectedItems;

    jobEditDto.JobEditJobCategories = this.jobEditJobCategorySelectedItems;
    jobEditDto.JobEditJobCode = this.jobEditJobCodeSelectedItems;
    jobEditDto.JobEditIncludeJobCode = this.jobEditIncludeJobCodeSelectedItems;
    jobEditDto.JobEditJobStatuses = this.jobEditJobStatusSelectedItems;
    jobEditDto.JobEditJobStatusBookings =
      this.jobEditJobStatusBookingSelectedItems;
    jobEditDto.RJEC_Learning = this.jobEditIsTR;
    jobEditDto.RJEC_ISDisabled = this.jobEditIsDisabled;
    jobEditDto.RJEC_IsPended = this.jobEditIsPended;
    jobEditDto.RJEC_IV_Disabled = this.jobEditIndividualView;
    jobEditDto.RJEC_EV_Disabled = this.jobEditEngagementView;

    resViewDto.ResViewSubAreas = this.resViewSubAreaSelectedItems;
    resViewDto.ResViewSubServiceLines = this.resViewSubServiceLineSelectedItems;
    resViewDto.ResViewManagerialCountries =
      this.resViewManageCountrySelectedItems;
    resViewDto.ResViewLegalEntities = this.resViewLegalEntitySelectedItems;
    resViewDto.ResViewCompanyCodes = this.resViewCompanyCodeSelectedItems;
    resViewDto.ResViewServiceLines = this.resViewServiceLineSelectedItems;
    resViewDto.ResViewBusinessUnits = this.resViewBusinessUnitSelectedItems;
    resViewDto.ResViewEconomicLocations = this.resViewEcLocationSelectedItems;
    resViewDto.ResViewSubManageUnits =
      this.resViewSubManagementUnitSelectedItems;
    resViewDto.ResViewCompetencies = this.resViewEngCompetencySelectedItems;
    resViewDto.ResViewDepartments = this.resViewHRDeptSelectedItems;
    resViewDto.ResViewCostCenters = this.resViewCostCenterSelectedItems;
    resViewDto.RRVC_RInactive = this.resViewIsActive;

    jobViewDto.JobViewSubAreas = this.jobViewSubAreaSelectedItems;
    jobViewDto.JobViewSubServiceLines = this.jobViewSubServiceLineSelectedItems;
    jobViewDto.JobViewManagerialCountries =
      this.jobViewManageCountrySelectedItems;
    jobViewDto.JobViewCompanyCodes = this.jobViewCompanyCodeSelectedItems;
    jobViewDto.JobViewServiceLines = this.jobViewServiceLineSelectedItems;
    jobViewDto.JobViewEconomicLocations = this.jobViewEcLocationSelectedItems;
    jobViewDto.JobViewCompetencies = this.jobViewEngCompetencySelectedItems;
    jobViewDto.JobViewCostCenters = this.jobViewCostCenterSelectedItems;

    jobViewDto.JobViewJobCategories = this.jobViewJobCategorySelectedItems;
    jobViewDto.JobViewJobCode = this.jobViewJobCodeSelectedItems;
    jobViewDto.JobViewIncludeJobCode = this.jobViewIncludeJobCodeSelectedItems;
    jobViewDto.JobViewJobStatuses = this.jobViewJobStatusSelectedItems;
    jobViewDto.JobViewjobStatusBookings =
      this.jobViewJobStatusBookingSelectedItems;
    jobViewDto.RJVC_Learning = this.jobViewIsTR;
    jobViewDto.RJVC_IsPended = this.jobViewIsPended;

    bookingConfigurationDto.RBC_BIDEWEEK = this.bookingCurrentWeekEdit;
    bookingConfigurationDto.RBC_BIDDWEEK = this.bookingCurrentWeekDelete;
    bookingConfigurationDto.RBC_BIDAWEEK = this.bookingCurrentWeekAdd;
    bookingConfigurationDto.RBC_BIDCWEEK = this.bookingCurrentWeekCopy;
    bookingConfigurationDto.RBC_BIDRWEEK = this.bookingCurrentWeekReplace;
    bookingConfigurationDto.RBC_BIDRAWEEK = this.bookingCurrentWeekReplaceAll;
    bookingConfigurationDto.RBC_BIDDTRNG = this.bookigTrainingEngagementDelete;
    bookingConfigurationDto.RBC_BIDETRNG = this.bookigTrainingEngagementEdit;
    bookingConfigurationDto.RBC_BIDDDELT = this.bookigDisabledDelete;
    bookingConfigurationDto.RBC_BIDEEDIT = this.bookigDisabledEdit;
    bookingConfigurationDto.RBC_BIDCCOPY = this.bookigDisabledCopy;
    bookingConfigurationDto.RBC_BIDRRPLC = this.bookigDisabledReplace;
    bookingConfigurationDto.RBC_BIDRARPLCA = this.bookigDisabledReplaceAll;
    if (this.disableActionsGhostBooking) {
      bookingConfigurationDto.RBC_BIDVGhost = this.bookingDisabledGhostView;
      bookingConfigurationDto.RBC_BIDEGhost = this.bookingDisabledGhostEdit;
      bookingConfigurationDto.RBC_BIDDGhost = this.bookingDisabledGhostDelete;
      bookingConfigurationDto.RBC_BIDCGhost = this.bookingDisabledGhostCopy;
      bookingConfigurationDto.RBC_BIDRGhost = this.bookingDisabledGhostReplace;
    }

    this.role.ResourceAddConfigurationDto = resAddDto; //Add Config
    this.role.ResourceDeleteConfigurationDto = resDeleteDto; //Delete Config
    this.role.ResourceReplaceConfigurationDto = resReplaceDto; //Replace Config
    this.role.ResourceReplaceAllConfigurationDto = resReplaceAllDto; //RepalceAll Config
    this.role.ResourceEditConfigurationDto = resEditDto;
    this.role.ResourceViewConfigurationDto = resViewDto;
    this.role.AssignmentConfigurationDto = assingmentDto;
    this.role.JobAddConfigurationDto = jobAddDto; //Add Config
    this.role.JobDeleteConfigurationDto = jobDeleteDto; //Delete Config
    this.role.JobReplaceConfigurationDto = jobReplaceDto; //Replace Config
    this.role.JobReplaceAllConfigurationDto = jobReplaceAllDto; //Replace Config
    this.role.JobEditConfigurationDto = jobEditDto;
    this.role.JobViewConfigurationDto = jobViewDto;
    this.role.BookingConfigurationDto = bookingConfigurationDto;
    this.role.RoleApprovalConfigurationDtos = this.approvalArrDtoForSubmission;
    this.role.RoleFeatureLevelConfigurationDtos = this.featureLevelDtos;
    // v5
    this.role.RoleReportConfigurationDtos = this.setRoleReportConfigDtoDetails();
    this.hasData = false;
    try {
    } catch (apiError) {
      console.log(apiError);
    }

    this.restService.submitRoleConfiguration(this.role).subscribe(
      (data) => {
        if (data != null) {
          if (data.customResultId <= 0) {
            this.SaveErrorMessage = data.customException;
            this.customResultId = data.customResultId;
            this.SaveSuccessMessage = '';
          } else {
            this.buttonText = 'Saved';
            this.customResultId = null;
            this.SaveErrorMessage = '';
            // v1
            //this.actionSelected = this.actionNameEnum.View;
            this.SaveSuccessMessage =
              'Role configuration submitted successfully';
            if (this.actionSelected == this.actionNameEnum.Copy) {
              this.role.R_ID = data.customResultId;
              let csRole = this.roleTypes.find(
                (x) => x.ID == this.selectedRoleType
              );
              if (csRole != null) {
                this.role.RoleTypeName = csRole.Text;
                this.restService.redirectToEdit(this.role);
              }
            }
              this.onScroll.emit();
          }
          this.errorMessage = '';
          this.isExistsAccessRole = false;
        }
      },
      (err) => {
        this.buttonText = 'Submit';
        this.hasData = true;
        if (err.status === 500) {
          this.SaveErrorMessage = err.error;
           setTimeout(() => {
            this.onScroll.emit();
            this.SaveErrorMessage = '';
          }, 5000);
        }
      },
      () => {
        this.spinner.hide();
        this.hasData = true;

        this.sortMultiSelectBasedOnSelection(ROLE_LAYERS.ASSIGNMENT_CONFIG);
        setTimeout(() => {
          this.buttonText = 'Submit';
          this.onScroll.emit();
          // setTimeout(() => {
          //   this.SaveSuccessMessage = '';
          //   this.SaveErrorMessage = '';
          // }, 5000);
        }, 2000);
      }
    );
  }

    
  private setRoleReportConfigDtoDetails():RoleReportConfigurationVM[] 
  {
        let arr : RoleReportConfigurationVM[] = [];
        this.assignmentManageReportSelectedItems.forEach(aa => {
          let obj = new RoleReportConfigurationVM;
          obj.RAC_R_ID = this.RoleId,
          obj.RAC_RP_ID = aa.Id
          arr.push(obj);
        });
        return arr;
  }

  onChangeRoleType() {
    this.managePrioirtyDisable();
    this.manageFeatureLevelConfiguration();
    this.makeDirty();
  }

  onCoWorkerChange() {
    if (this.selectedDelegate && this.selectedCoworkers)
      this.selectedDelegate = false;
    this.makeDirty();
  }

  onDelegateChange() {
    if (this.selectedDelegate && this.selectedCoworkers)
      this.selectedCoworkers = false;
    this.makeDirty();
  }

  onJobAssignmentComponentChange(type) {
    if (type === 'job') {
      this.selectedJobAssignment = !this.selectedJobAssignment;
    } else {
      this.selectedComponent = !this.selectedComponent;
    }
    this.makeDirty();
  }

  onKeyPressAccessRole() {
    if (this.isExistsAccessRole == true) {
      this.isExistsAccessRole = false;
    }
  }

  onChangeOutCheckAccessRole() {
    if (this.accessRoleName != '') {
      this.restService
        .checkAccessRole(this.RoleId, this.accessRoleName)
        .subscribe((data) => {
          this.isExistsAccessRole = data;
          this.errorMessage = 'Role Name is already exists';
        });
    }
    this.isExistsAccessRole = false;
    this.errorMessage = '';
    this.makeDirty();
  }

  getUserInstances() {
    const userInstance = this.sharedService.getStoredUserInstances();

    if (userInstance === null || userInstance === undefined) {
      this.sharedService.getUserInstances().subscribe((data) => {
        this.instances = this.sharedService.getStoredUserInstances();
        const selected = this.instances?.filter(
          (x) => x?.InstanceId === this.selectedInstance
        );
        if (selected && selected.length) {
          this.selectedInstance = selected[0]?.InstanceId;
        }
      });
    } else {
      this.instances = userInstance;
      const selected = this.instances?.filter(
        (x) => x.InstanceId === this.selectedInstance
      );
      if (selected && selected.length > 0) {
        this.selectedInstance = selected[0].InstanceId;
      }
    }
  }
  onInstanceChange(event) {
    this.selectedInstance = event.value;
  }

  onHomeBasedInstanceChange(event) {
    this.makeDirty();
    this.isHomeRetainNotSelected = false;
    this.selectedHomeBasedInstance = event.value;
  }

  manageFeatureLevelConfiguration() {
    let csRole = this.roleTypes.find((x) => x.ID == this.selectedRoleType);
    if (csRole != null && csRole.Code == this.roleTypeEnum.ClientServer) {
      this.featuresfilterList = this.featureDataList.filter(
        (x) => x.Code == this.roleTypeEnum.ClientServer
      );
    } else if (
      csRole != null &&
      csRole.Code == this.roleTypeEnum.ResourceAdmin
    ) {
      this.featuresfilterList = this.featureDataList.filter(
        (x) => x.Code == this.roleTypeEnum.ResourceAdmin
      );
    }
    this.featuresList = [];
    if (this.featuresfilterList != null) {
      this.featuresfilterList.forEach((element) => {
        this.featureField = { [`${element.Text}`]: false };
        this.featuresList = this.featuresList.concat({
          Id: element.ID,
          Text: element.ParentName + ' - ' + element.Text,
        });
      });
      if (this.fetchedFeatureLevelDtos?.length)
        this.bindFeatureLevelFields(this.fetchedFeatureLevelDtos);
    }
  }
  //#endregion
}
